import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import ModalImage from "react-modal-image";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import CurrencyInput from "react-currency-input-field";
import FeatherIcon from "feather-icons-react";
import CountUp from "react-countup";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../../store/paymentMethod/action";
import { resetUserState, getUser } from "../../../store/users/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetCivilBudgetState, getCivilBudget } from "../../../store/civilBudget/action";
import { resetSalesState, getSales } from "../../../store/sales/action";
import { resetPurchaseState, getPurchase } from "../../../store/purchase/action";
import { resetLegalState, getLegal } from "../../../store/legal/action";
import { resetLegalMasterState, getLegalMaster } from "../../../store/legalMaster/action";
import { resetLegalPermissionState, getLegalPermission } from "../../../store/legalPermission/action";
import { resetLegalFractionState, getLegalFraction } from "../../../store/legalFraction/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { resetTransactionTaxState, getTransactionTax } from "../../../store/transactionTax/action";
import { getAccTag } from "../../../store/accTag/action";
import { getCivilContract, resetCivilContractState } from "../../../store/civilContract/action";
import { resetAccTransState, getAccTrans as onGetAccTranss, addNewAccTrans as onAddNewAccTrans, updateAccTrans as onUpdateAccTrans, deleteAccTrans as onDeleteAccTrans, getAccTransLoading, resetAccTransCreateState } from "../../../store/accTrans/action";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import PrintDoc from "./PrintDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { ButtonPrint, PrintDocExpense } from "./PrintDocExpense";

const AccTrans = () => {
  const { id } = useParams();

  const idParam = id;

  const printInvoiceRef = useRef(null);
  const printRef = useRef(null);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalDetailExpense, setModalDetailExpense] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [activeProgress, setActiveProgress] = useState("all");
  const [pageIdx, setPageIdx] = useState(0);
  const [indexPage, setIndexPage] = useState(0);

  const dispatch = useDispatch();

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    accTranss,
    accTransAdded,
    isAccTransCreated,
    isAccTransSuccess,
    loading,
    error,
    budgets,
    budgetLoading,
    legals,
    legalLoading,
    legalMasters,
    legalMasterLoading,
    legalFractions,
    legalFractionLoading,
    legalPermissions,
    legalPermissionLoading,
    companies,
    companyLoading,
    clients,
    clientLoading,
    users,
    userLoading,
    transactionTaxs,
    accTags,
    accTagLoading,
    transactionTaxLoading,
    accAccounts,
    accAccountLoading,
    departments,
    departmentLoading,
    civilBudgets,
    civilBudgetLoading,
    branches,
    branchLoading,
    saless,
    salesLoading,
    purchases,
    purchaseLoading,
    paymentMethods,
    paymentMethodLoading,
    civilContracts,
    civilContractLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    accTransAdded: state.AccTrans.accTransAdded,
    accTranss: state.AccTrans.accTranss,
    loading: state.AccTrans.loading,
    isAccTransCreated: state.AccTrans.isAccTransCreated,
    isAccTransSuccess: state.AccTrans.isAccTransSuccess,
    error: state.AccTrans.error,
    legals: state.Legal.legals,
    legalLoading: state.Legal.loading,
    legalFractions: state.LegalFraction.legalFractions,
    legalFractionLoading: state.LegalFraction.loading,
    legalMasters: state.LegalMaster.legalMasters,
    legalMasterLoading: state.LegalMaster.loading,
    legalPermissions: state.LegalPermission.legalPermissions,
    legalPermissionLoading: state.LegalPermission.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    users: state.Users.users,
    userLoading: state.Users.loading,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    transactionTaxLoading: state.TransactionTax.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    saless: state.Sales.saless,
    salesLoading: state.Sales.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
    accTags: state.AccTag.accTags,
    accTagLoading: state.AccTag.loading,
    purchases: state.Purchase.purchases,
    purchaseLoading: state.Purchase.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    civilContracts: state.CivilContract.civilContracts,
    civilContractLoading: state.CivilContract.loading,
  }));

  const [accTransList, setAccTransList] = useState([]);
  const [accTransDoc, setAccTransDoc] = useState([]);
  const [accTrans, setAccTrans] = useState([]);
  const [accTag, setAccTag] = useState("");
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [userList, setUserList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [filterAcc, setFilterAcc] = useState();
  const [searchBudget, setSearchBudget] = useState("");
  const [searchDepartment, setSearchDepartment] = useState("");
  const [branchIdSelected, setBranchIdSelected] = useState(null);

  const [isEdit, setIsEdit] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [isRelease, setIsRelease] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [tagList, setTagList] = useState([]);

  const [salesList, setSalesList] = useState([]);
  const [purchaseList, setPurchaseList] = useState([]);
  const [civilContractList, setCivilContractList] = useState([]);
  const [legalList, setLegalList] = useState([]);
  const [legalAssetList, setLegalAssetList] = useState([]);
  const [legalMasterList, setLegalMasterList] = useState([]);
  const [legalPermissionList, setLegalPermissionList] = useState([]);
  const [legalFractionList, setLegalFractionList] = useState([]);
  const [budgetList, setBudgetList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudgetDetailList, setCivilBudgetDetailList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentSelect, setDepartmentSelect] = useState(null);

  const [modalMedia, setModalMedia] = useState(false);
  const [docImg, setDocImg] = useState([]);

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const [isBudget, setIsBudget] = useState(false);
  const [isLegal, setIsLegal] = useState(false);
  const [isSales, setIsSales] = useState(false);
  const [isPurchase, setIsPurchase] = useState(false);
  const [isCivilContract, setIsCivilContract] = useState(false);

  const transTypeData = [
    {
      options: [
        { label: "PENERIMAAN CASH", value: "CASH IN" },
        { label: "PENGELUARAN CASH", value: "CASH OUT" },
        { label: "PIUTANG", value: "RECEIVABLE" },
        { label: "HUTANG", value: "PAYABLE" },
        { label: "LAINNYA", value: "OTHER" },
      ],
    },
  ];

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAccTranss = accTranss;
      if (type !== "all") {
        if (activeProgress !== "all") {
          if (type === "APPROVED CASHOUT") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.type === activeProgress && accTrans?.statusId === 2 && accTrans?.approval && accTrans?.type === "CASH OUT");
          } else if (type === "JOURNAL") {
            filteredAccTranss = accTranss.filter((accTrans) => (accTrans?.at_detail?.length <= 1 || parseFloat(accTrans?.at_detail[0]?.accId || 0) === 0) && accTrans.statusId !== 4);
          } else if (type === "DRAFT") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.type === activeProgress && accTrans?.statusId === 1);
          } else if (type === "CASHFLOW") {
            filteredAccTranss = accTranss.filter((accTrans) => !accTrans.budgetId && accTrans.statusId !== 4);
          } else if (type === "PELUNASAN") {
            filteredAccTranss = accTranss.filter((data) => accTrans?.type === activeProgress && (data.type === "PAYABLE" || data.type === "RECEIVABLE") && !data.purchaseId && !data.civilContractId);
          } else if (type === "DOC") {
            filteredAccTranss = accTranss.filter((data) => (data?.at_file || []).length === 0 && data?.type === "CASH OUT" && data.statusId !== 4);
          } else if (type === "CORRECTION") {
            let targetKeys = [];
            accTranss.filter(f => f.type === 'CASH OUT' && f?.at_rls?.length).forEach(element => {
              let arr = [];
              (element.at_rls || []).forEach((o, i) => {
                if (o?.type === "Keuangan") {
                  const hasArr = arr.includes(o?.at_rls_trx?.at_cvl?.type);
                  if (!hasArr)
                    arr.push(o?.at_rls_trx?.at_cvl?.type);
                }

                if (o?.type === "SPK") {
                  const hasArr = arr.includes(o?.at_rls_contract?.cvl_contract_cvl_budget?.type);
                  if (!hasArr)
                    arr.push(o?.at_rls_contract?.cvl_contract_cvl_budget?.type);
                }

                if (o?.type === "Material") {
                  (o?.at_rls_purchase?.purchase_detail || []).forEach(p => {
                    const hasArr = arr.includes(p?.purchase_cvl_budget?.type);
                    if (!hasArr)
                      arr.push(p?.purchase_cvl_budget?.type);
                  });
                }
              });

              let release_amount = (element.at_rls || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
              let amount = element.amount;

              if (arr.length > 1 || (parseFloat(release_amount) !== parseFloat(amount)))
                targetKeys.push(element.id);
            });

            filteredAccTranss = accTranss.filter((data) => targetKeys.includes(data.id));
          } else {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.type === activeProgress && accTrans?.at_status?.name === type);
          }
        } else {
          if (type === "APPROVED CASHOUT") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.statusId === 2 && accTrans?.approval && accTrans?.type === "CASH OUT");
          } else if (type === "JOURNAL") {
            filteredAccTranss = accTranss.filter((accTrans) => (accTrans?.at_detail?.length <= 1 || parseFloat(accTrans?.at_detail[0]?.accId || 0) === 0) && accTrans.statusId !== 4);
          } else if (type === "DRAFT") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.statusId === 1);
          } else if (type === "CASHFLOW") {
            filteredAccTranss = accTranss.filter((accTrans) => !accTrans.budgetId && accTrans.statusId !== 4);
          } else if (type === "PELUNASAN") {
            filteredAccTranss = accTranss.filter((data) => (data.type === "PAYABLE" || data.type === "RECEIVABLE") && !data.purchaseId && !data.civilContractId);
          } else if (type === "DOC") {
            filteredAccTranss = accTranss.filter((data) => (data?.at_file || []).length === 0 && data?.type === "CASH OUT" && data.statusId !== 4);
          } else if (type === "CORRECTION") {
            let targetKeys = [];
            accTranss.filter(f => f.type === 'CASH OUT' && f?.at_rls?.length).forEach(element => {
              let arr = [];
              (element.at_rls || []).forEach((o, i) => {
                if (o?.type === "Keuangan") {
                  const hasArr = arr.includes(o?.at_rls_trx?.at_cvl?.type);
                  if (!hasArr)
                    arr.push(o?.at_rls_trx?.at_cvl?.type);
                }

                if (o?.type === "SPK") {
                  const hasArr = arr.includes(o?.at_rls_contract?.cvl_contract_cvl_budget?.type);
                  if (!hasArr)
                    arr.push(o?.at_rls_contract?.cvl_contract_cvl_budget?.type);
                }

                if (o?.type === "Material") {
                  (o?.at_rls_purchase?.purchase_detail || []).forEach(p => {
                    const hasArr = arr.includes(p?.purchase_cvl_budget?.type);
                    if (!hasArr)
                      arr.push(p?.purchase_cvl_budget?.type);
                  });
                }
              });
              let release_amount = (element.at_rls || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
              let amount = element.amount;

              if (arr.length > 1 || (parseFloat(release_amount) !== parseFloat(amount)))
                targetKeys.push(element.id);
            });

            filteredAccTranss = accTranss.filter((data) => targetKeys.includes(data.id));
          } else {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.at_status?.name === type);
          }
        }
      }
      setAccTransList(filteredAccTranss);
    }
  };

  const toggleProgress = (type) => {
    let filteredAccTranss = accTranss;
    setActiveProgress(type);
    setActiveTab("1");
    setActiveTypeTab("all");
    if (type !== "all") {
      filteredAccTranss = accTranss.filter((trans) => trans.type === type);
    }
    setAccTransList(filteredAccTranss);
  };

  useEffect(() => {
    if (companySelected && branchSelected) {
      setDepartmentSelect({ label: userData?.user?.user_department?.name, value: userData?.user?.user_department?.id });
      setBranchIdSelected(branchSelected?.value);
      setSearchBudget("");
      handleGetBudget(companySelected?.value, branchSelected?.value);
      handleGetAccTrans(companySelected?.value, branchSelected?.value);
    }
  }, [companySelected, branchSelected, idParam]);

  const handleGetAccTrans = (companyId, branchId) => {
    dispatch(resetAccTransState());
    const params = { companyId: companyId, branchId: branchId };
    const idParamInt = parseInt(idParam, 10);
    if (typeof idParamInt === "number" && !isNaN(idParamInt)) {
      params.accId = idParamInt;
    }
    dispatch(onGetAccTranss(params));
    handleGetUser(companyId);
    handleGetTag(companyId);
    handleGetAccAccount(companyId);
    handleGetTransactionTax(companyId);
    handleGetDepartement(companyId);
    handleGetPaymentMethod(companyId, branchId);
  };

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, status: 2, type: "all" })); //branchId: branchId,
  };

  const handleGetSales = (companyId, branchId) => {
    dispatch(resetSalesState());
    dispatch(getSales({ companyId: companyId, branchId: branchId, simple: "true", date: "all" }));
  };

  const handleGetCivilContract = (companyId, branchId) => {
    dispatch(resetCivilContractState());
    dispatch(getCivilContract({ companyId: companyId, branchId: branchId }));
  };

  const handleGetPurchase = (companyId, branchId) => {
    dispatch(resetPurchaseState());
    dispatch(getPurchase({ companyId: companyId, branchId: branchId, date: "all" }));
  };

  const handleGetLegal = (companyId) => {
    dispatch(resetLegalState());
    dispatch(getLegal({ companyId: companyId, status: 2 }));
  };

  const handleGetLegalMaster = (companyId, branchId) => {
    dispatch(resetLegalMasterState());
    dispatch(getLegalMaster({ companyId: companyId, branchId: branchId, status: 2 }));
  };

  const handleGetLegalPermisson = (companyId, branchId) => {
    dispatch(resetLegalPermissionState());
    dispatch(getLegalPermission({ companyId: companyId, branchId: branchId, status: 2 }));
  };

  const handleGetLegalFraction = (companyId, branchId) => {
    dispatch(resetLegalFractionState());
    dispatch(getLegalFraction({ companyId: companyId, branchId: branchId, status: 2 }));
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetCivilBudget = (companyId, branchId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId, branchId: branchId }));
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  const handleGetUser = (companyId) => {
    dispatch(resetUserState());
    dispatch(getUser({ status: 2 }));
  };

  const handleGetTag = (companyId) => {
    dispatch(getAccTag({ companyId: companyId, status: 2 }));
  };

  const handleGetTransactionTax = (companyId) => {
    dispatch(resetTransactionTaxState());
    dispatch(getTransactionTax({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    setInfo(accTransAdded);
  }, [accTransAdded]);

  useEffect(() => {
    if (!isEmpty(accTranss)) {
      let filteredAccTranss = accTranss;
      if (activeTypeTab !== "all") {
        if (activeProgress !== "all") {
          if (activeTypeTab === "APPROVED CASHOUT") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.activeProgress === activeProgress && accTrans?.statusId === 2 && accTrans?.approval && accTrans?.type === "CASH OUT");
          } else if (activeTypeTab === "JOURNAL") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.activeProgress === activeProgress && (accTrans?.at_detail?.length === 0 || parseFloat(accTrans?.at_detail[0]?.accId || 0) === 0));
          } else if (activeTypeTab === "DRAFT") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.activeProgress === activeProgress && accTrans?.statusId === 1);
          } else if (activeTypeTab === "PELUNASAN") {
            filteredAccTranss = accTranss.filter((data) => accTrans?.activeProgress === activeProgress && (data.type === "PAYABLE" || data.type === "RECEIVABLE") && !data.purchaseId && !data.civilContractId);
          } else {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.activeProgress === activeProgress && accTrans?.at_status?.name === activeTypeTab);
          }
        } else {
          if (activeTypeTab === "APPROVED CASHOUT") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.statusId === 2 && accTrans?.approval && accTrans?.type === "CASH OUT");
          } else if (activeTypeTab === "JOURNAL") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.at_detail?.length === 0 || parseFloat(accTrans?.at_detail[0]?.accId || 0) === 0);
          } else if (activeTypeTab === "DRAFT") {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.statusId === 1);
          } else if (activeTypeTab === "PELUNASAN") {
            filteredAccTranss = accTranss.filter((data) => (data.type === "PAYABLE" || data.type === "RECEIVABLE") && !data.purchaseId && !data.civilContractId);
          } else {
            filteredAccTranss = accTranss.filter((accTrans) => accTrans?.at_status?.name === activeTypeTab);
          }
        }
      }
      setAccTransList(filteredAccTranss.map((el) => ({ ...el, isChecked: false })));
      setInfo(accTranss[accTranss.length - 1]);
    } else {
      setAccTransList([]);
      setInfo({});
    }
  }, [accTranss]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "tanggal",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Kode Akun",
        isSelected: true,
        data: [],
      },
      {
        id: "account",
        label: "Akun",
        isSelected: true,
        data: [],
      },
      {
        id: "debit",
        label: "Debit",
        isSelected: true,
        data: [],
      },
      {
        id: "credit",
        label: "Credit",
        isSelected: true,
        data: [],
      },
      {
        id: "status",
        label: "Status",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Nilai Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "cashflow",
        label: "Cashflow",
        isSelected: true,
        data: [],
      },
      {
        id: "branch",
        label: "Cabang",
        isSelected: true,
        data: [],
      },
      {
        id: "department",
        label: "Departemen",
        isSelected: true,
        data: [],
      },
      {
        id: "at_cvl",
        label: "RAB",
        isSelected: true,
        data: [],
      },
      {
        id: "at_cvl_account",
        label: "Uraian RAB",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (accTransList.length > 0) {
      accTransList.forEach((item) => {
        if (item.isChecked) {
          let first = true;

          if ((item.at_detail.length || []).length > 0) {
            item.at_detail.forEach((it, idx) => {
              let doc = dataDoc.find((d) => d.id === "tanggal");
              if (doc) doc.data.push(handleValidDate(item.transactionat));
              if (first) {
                doc = dataDoc.find((d) => d.id === "transaction_no");
                if (doc) doc.data.push(item?.transaction_no);

                doc = dataDoc.find((d) => d.id === "code");
                if (doc) doc.data.push(it?.at_detail_account?.code);

                doc = dataDoc.find((d) => d.id === "account");
                if (doc) doc.data.push(it?.at_detail_account?.name);

                doc = dataDoc.find((d) => d.id === "debit");
                if (doc) doc.data.push(parseFloat(it?.debit));

                doc = dataDoc.find((d) => d.id === "credit");
                if (doc) doc.data.push(parseFloat(it?.credit));

                doc = dataDoc.find((d) => d.id === "status");
                if (doc) doc.data.push(item?.at_status?.name);

                doc = dataDoc.find((d) => d.id === "type");
                if (doc) doc.data.push(item?.type);

                doc = dataDoc.find((d) => d.id === "amount");
                if (doc) doc.data.push(parseFloat(item?.amount));

                doc = dataDoc.find((d) => d.id === "branch");
                if (doc) doc.data.push(item?.at_branch?.name);

                doc = dataDoc.find((d) => d.id === "department");
                if (doc) doc.data.push(item?.at_department?.name);

                doc = dataDoc.find((d) => d.id === "cashflow");
                if (doc) doc.data.push(item?.at_budget?.name);

                doc = dataDoc.find((d) => d.id === "description");
                if (doc) doc.data.push(item?.description);

                doc = dataDoc.find((d) => d.id === "at_cvl");
                if (doc) doc.data.push(item?.at_cvl?.name);

                doc = dataDoc.find((d) => d.id === "at_cvl_account");
                if (doc) doc.data.push(item?.at_cvl_account?.name);

                first = false;
              } else {
                doc = dataDoc.find((d) => d.id === "transaction_no");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "code");
                if (doc) doc.data.push(it?.at_detail_account?.code);

                doc = dataDoc.find((d) => d.id === "account");
                if (doc) doc.data.push(it?.at_detail_account?.name);

                doc = dataDoc.find((d) => d.id === "debit");
                if (doc) doc.data.push(parseFloat(it?.debit));

                doc = dataDoc.find((d) => d.id === "credit");
                if (doc) doc.data.push(parseFloat(it?.credit));

                doc = dataDoc.find((d) => d.id === "type");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "status");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "amount");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "branch");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "department");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "cashflow");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "description");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "at_cvl");
                if (doc) doc.data.push("");

                doc = dataDoc.find((d) => d.id === "at_cvl_account");
                if (doc) doc.data.push("");
              }
            });
          } else {
            let doc = dataDoc.find((d) => d.id === "tanggal");
            if (doc) doc.data.push(handleValidDate(item.transactionat));

            doc = dataDoc.find((d) => d.id === "transaction_no");
            if (doc) doc.data.push(item?.transaction_no);

            doc = dataDoc.find((d) => d.id === "code");
            if (doc) doc.data.push("");

            doc = dataDoc.find((d) => d.id === "account");
            if (doc) doc.data.push("");

            doc = dataDoc.find((d) => d.id === "debit");
            if (doc) doc.data.push("");

            doc = dataDoc.find((d) => d.id === "credit");
            if (doc) doc.data.push("");

            doc = dataDoc.find((d) => d.id === "status");
            if (doc) doc.data.push(item?.at_status?.name);

            doc = dataDoc.find((d) => d.id === "type");
            if (doc) doc.data.push(item?.type);

            doc = dataDoc.find((d) => d.id === "amount");
            if (doc) doc.data.push(parseFloat(item?.amount));

            doc = dataDoc.find((d) => d.id === "branch");
            if (doc) doc.data.push(item?.at_branch?.name);

            doc = dataDoc.find((d) => d.id === "department");
            if (doc) doc.data.push(item?.at_department?.name);

            doc = dataDoc.find((d) => d.id === "cashflow");
            if (doc) doc.data.push(item?.at_budget?.name);

            doc = dataDoc.find((d) => d.id === "description");
            if (doc) doc.data.push(item?.description);

            doc = dataDoc.find((d) => d.id === "at_cvl");
            if (doc) doc.data.push(item?.at_cvl?.name);

            doc = dataDoc.find((d) => d.id === "at_cvl_account");
            if (doc) doc.data.push(item?.at_cvl_account?.name);
          }
        }
      });
    }

    setAccTransDoc(dataDoc);
  }, [accTransList]);

  const reactToPrintContent = useCallback(() => {
    return printInvoiceRef.current;
  }, [printInvoiceRef]);

  const handleAfterPrint = useCallback(() => { }, []);

  const handleBeforePrint = useCallback(() => { }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(transactionTaxs)) {
      var data = [];
      var opt = [];
      transactionTaxs.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const amount = parseInt(item.amount) || 0;
        var obj = { label: name, value: id, amount: amount };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTaxList(data);
    }
  }, [transactionTaxs]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        const categoryCode = item?.acc_account_category?.code;
        var obj = { label: code + " " + name, value: id, category: categoryCode };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const label = item?.pm_branch?.branch_code ? name + " - " + item?.pm_branch?.branch_code : name;
        const id = item.id;
        var obj = { label: label, value: id, sort_order: item?.sort_order + "-", item: item, tag: { label: item?.pm_tag?.name, value: item.tagId } };
        if (accTag) {
          if (item.tagId && accTag === item.tagId)
            opt.push(obj);
        }
        else
          opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => a.sort_order.localeCompare(b.sort_order, undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setPaymentMethodList(data);
    } else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods, accTag]);

  useEffect(() => {
    if (!isEmpty(accTags)) {
      var data = [];
      var opt = [{ label: "NON TAG", value: "" }];
      accTags.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", undefined, { numeric: true, sensitivity: "base" })).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTagList(data);
    }
  }, [accTags]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      var civilBudgetData = [];
      var civilBudgetDetailData = [];
      var opt = [];
      var opt_detail = [];
      civilBudgets.forEach((it, idx) => {
        if (branchIdSelected === it.branchId) {
          const title = it.name ? it.name : "";
          const type = it.type ? it.type : "";
          const budgetId = it.id ? it.id : "";
          it.cvl_detail.forEach((item, key) => {
            if (type === "INFRASTRUKTUR" || type === "BANGUNAN" || type === "PEKERJAAN TAMBAH 1" || type === "PEKERJAAN TAMBAH 2" || type === "PEKERJAAN TAMBAH 3" || type === "PEKERJAAN TAMBAH 4" || type === "PEKERJAAN TAMBAH 5" || type === "PEKERJAAN TAMBAH 6" || type === "PEKERJAAN TAMBAH 7" || type === "PEKERJAAN TAMBAH 8" || type === "LISTRIK JARINGAN") {
              const name = item.cvld_account ? type + " - " + item.cvld_account.name : "";
              const id = item.cvld_account ? item.cvld_account.id : "";
              opt_detail.push({ label: name, value: id, civilBudgetDetailId: item.id, civilBudgetId: budgetId, civilAccountId: id });
            }
          });
          opt.push({ label: title, value: budgetId, type: type });
        }
      });
      var option_detail = { options: opt_detail.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      civilBudgetDetailData.push(option_detail);
      setCivilBudgetDetailList(civilBudgetDetailData);

      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      civilBudgetData.push(option);
      setCivilBudgetList(civilBudgetData);
    } else {
      setCivilBudgetDetailList([]);
      setCivilBudgetList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  useEffect(() => {
    if (!isEmpty(saless)) {
      var data = [];
      var opt = [];
      saless.forEach((item, key) => {
        const transaction_no = item.transaction_no;
        const transactionat = item.transactionat;
        const customer = item.sales_customer ? item.sales_customer.name : "";
        const id = item.id;
        var obj = { label: transaction_no + " - " + customer + " / " + handleValidDate(transactionat), value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setSalesList(data);
    }
  }, [saless]);

  useEffect(() => {
    if (!isEmpty(legals)) {
      var data = [];
      var opt = [];
      var data_asset = [];
      var opt_asset = [];
      legals.forEach((item, key) => {
        const name = item.name;
        const code = item.code ? item.code + " : " + name + ", " : "";
        const quantity = item.quantity;
        const owner = item.owner;
        const nominatif = item.nominatif;
        const id = item.id;
        var obj = { label: code + owner + " - " + parseFloat(quantity) + " M²", value: id, type: item.type };
        if (item.type === "inventory") opt.push(obj);

        var obj_asset = { label: nominatif + " - " + parseFloat(quantity) + " M²", value: id, type: item.type };
        if (item.type === "asset") opt_asset.push(obj_asset);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setLegalList(data);

      var option_asset = { options: opt_asset.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data_asset.push(option_asset);
      setLegalAssetList(data_asset);
    }
  }, [legals]);

  useEffect(() => {
    if (!isEmpty(legalMasters)) {
      var data = [];
      var opt = [];
      legalMasters.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setLegalMasterList(data);
    }
  }, [legalMasters]);

  useEffect(() => {
    if (!isEmpty(legalFractions)) {
      var data = [];
      var opt = [];
      legalFractions.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setLegalFractionList(data);
    }
  }, [legalFractions]);

  useEffect(() => {
    if (!isEmpty(legalPermissions)) {
      var data = [];
      var opt = [];
      legalPermissions.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: item?.legal_per_document?.name + " - " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setLegalPermissionList(data);
    }
  }, [legalPermissions]);

  useEffect(() => {
    if (!isEmpty(civilContracts)) {
      var data = [];
      var opt = [];
      civilContracts.forEach((item, key) => {
        const transaction_no = item.transaction_no;
        const transactionat = item.transactionat;
        const customer = item.cvl_contract_vendor ? item.cvl_contract_vendor.name : "";
        const id = item.id;
        var obj = { label: transaction_no + " - " + customer + " / " + currencyFormat(item.amount) + " - " + handleValidDate(transactionat), value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setCivilContractList(data);
    }
  }, [civilContracts]);

  useEffect(() => {
    if (!isEmpty(purchases)) {
      var data = [];
      var opt = [];
      purchases.forEach((item, key) => {
        const transaction_no = item.transaction_no;
        const transactionat = item.transactionat;
        const customer = item.purchase_vendor ? item.purchase_vendor.name : "";
        const id = item.id;
        var obj = { label: transaction_no + " - " + customer + " / " + currencyFormat(item.total_amount) + " - " + handleValidDate(transactionat), value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setPurchaseList(data);
    }
  }, [purchases]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "NON CASHFLOW", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name + ", " + item?.budget_branch?.branch_code;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })).reverse() };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (!isEmpty(users)) {
      var userData = [];
      var opt = [];
      users.forEach((item, key) => {
        const name = item.name;
        const company = item?.user_company?.name;
        const type = item.userType === "user" || item.userType === "holding" || item.userType === "admin" || item.userType === "client" || item.userType === "company" ? "Karyawan" : item.userType === "vendor" ? "Supplier" : item.userType === "agent" ? "Salesman" : "Konsumen";
        const id = item.id;
        var obj = { label: name + ",  " + company + " (" + type + ")", value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      userData.push(option);
    }
    setUserList(userData);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  const onClickDelete = (accTrans) => {
    setAccTrans(accTrans);
    setDeleteModal(true);
  };

  const handleDeleteAccTrans = () => {
    if (accTrans) {
      dispatch(onDeleteAccTrans(accTrans));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAccTrans(null);
      setDocImg([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setAccTrans(null);
      setDocImg([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleDetailExpense = useCallback(() => {
    if (modalDetailExpense) {
      setModalDetailExpense(false);
    } else {
      setModalDetailExpense(true);
    }
  }, [modalDetailExpense]);

  const handleAccTransClick = useCallback((arg, type) => {
    const data = arg;
    let accTransDetail = [];
    if (data.at_detail) {
      for (const element of data.at_detail) {
        accTransDetail.push({
          itemId: element.id,
          description: element.description,
          sort_order: parseInt(element.sort_order),
          debit: parseFloat(element.debit || 0),
          credit: parseFloat(element.credit || 0),
          accId: element.accId,
          acc: { label: element.at_detail_account && element.at_detail_account.name, value: element.at_detail_account && element.at_detail_account.id },
          isPrimary: element.isPrimary,
        });
      }
    }

    let files = [];
    if (data.at_file && data.at_file.length > 0) {
      data.at_file.forEach((element) => {
        files.push({
          filename: element.filename,
          originalname: element.originalname,
        });
      });
    }
    if (files.length > 0) setDocImg(files);
    setBranchIdSelected(data.branchId);
    handleGetCivilBudget(data.companyId, data.branchId);
    handleGetBudget(data.companyId, data.branchId);

    let transType;
    switch (data.type) {
      case "CASH IN":
        transType = { label: "PENERIMAAN CASH", value: "CASH IN" };
        break;
      case "CASH OUT":
        transType = { label: "PENGELUARAN CASH", value: "CASH OUT" };
        break;
      case "RECEIVABLE":
        transType = { label: "PIUTANG", value: "RECEIVABLE" };
        break;
      case "PAYABLE":
        transType = { label: "HUTANG", value: "PAYABLE" };
        break;
      default:
        transType = { label: "OTHER", value: "OTHER" };
        break;
    }

    setIsBudget(false);
    if (data.civilAccountId || data.civilBudgetId) {
      setIsBudget(true);
    }

    setIsSales(false);
    if (data.salesId) {
      setIsSales(true);
      handleGetSales(data.companyId, data.branchId);
    }

    setIsPurchase(false);
    if (data.purchaseId) {
      setIsPurchase(true);
      handleGetPurchase(data.companyId, data.branchId);
    }

    setIsCivilContract(false);
    if (data.civilContractId) {
      setIsCivilContract(true);
      handleGetCivilContract(data.companyId, data.branchId);
    }

    setIsLegal(false);
    if (data.legalId || data.legalMasterId || data.legalPermissionId || data.legalFractionalId) {
      setIsLegal(true);
      handleGetLegal(data.companyId);
      handleGetLegalFraction(data.companyId, data.branchId);
      handleGetLegalMaster(data.companyId, data.branchId);
      handleGetLegalPermisson(data.companyId, data.branchId);
    }

    setAccTrans({
      id: data.id,
      accTransPaymentId: type === "payment" ? data.id : data.accTransPaymentId,
      statusId: data.statusId,
      companyId: data.companyId,
      branchId: data.branchId,
      approval: data.approval,
      departmentId: data.departmentId,
      cvl_budget: data.at_cvl_budget && {
        label: data?.at_cvl?.name + " - " + data?.at_cvl_account?.name,
        value: data.at_cvl_account ? data.at_cvl_account.id : "",
        civilAccountId: data.at_cvl_account ? data.at_cvl_account.id : "",
        civilBudgetDetailId: data.at_cvl_budget.id,
        civilBudgetId: data.civilBudgetId,
      },
      description: data.description,
      code: data.code,
      transaction_no: data.transaction_no,
      transactionat: data.transactionat,
      paid_amount: data.paid_amount,
      amount: parseFloat(data.amount),
      type: type === "payment" ? { label: "PENGELUARAN CASH", value: "CASH OUT" } : transType,
      paymentMethod: data.at_pm && {
        label: data.at_pm.name,
        value: data.at_pm.id,
      },
      at_department: data.at_department,
      at_branch: data.at_branch,
      at_cvl_budget: data.at_cvl_budget,
      civilContract: data.at_cvl_contract && { label: data.at_cvl_contract.transaction_no, value: data.at_cvl_contract.id },
      sales: data.at_sales && { label: data.at_sales.transaction_no, value: data.at_sales.id },
      purchase: data.at_purchase && { label: data.at_purchase.transaction_no, value: data.at_purchase.id },
      legal: data.at_legal?.type === "inventory" && data.at_legal && { label: data.at_legal.name + ", " + data.at_legal.owner + " - " + parseFloat(data.at_legal.quantity) + " M²", value: data.at_legal.id, type: data.at_legal.type },
      legal_asset: data.at_legal?.type === "asset" && data.at_legal && { label: data.at_legal.nominatif + " - " + parseFloat(data.at_legal.quantity) + " M²", value: data.at_legal.id, type: data.at_legal.type },
      legal_master: data.at_legal_mst && { label: data.at_legal_mst.name, value: data.at_legal_mst.id },
      legal_fraction: data.at_legal_fractional && { label: data.at_legal_fractional.name, value: data.at_legal_fractional.id },
      legal_permission: data.at_legal_per && { label: data?.at_legal_per?.legal_per_document?.name + "-" + data.at_legal_per.name, value: data.at_legal_per.id },
      department: data.at_department && { label: data.at_department.name, value: data.at_department.id },
      tag: data.at_tag && { label: data.at_tag.name, value: data.at_tag.id },
      branch: data.at_branch && { label: data.at_branch.name, value: data.at_branch.id },
      company: data.at_company && { label: data.at_company.name, value: data.at_company.id },
      client: data.at_client && { label: data.at_client.name, value: data.at_client.id },
      budget: data.at_budget && { label: data.at_branch.branch_code + " - " + data.at_budget.name, value: data.at_budget.id },
      user: data.at_user && {
        label: data.at_user.name,
        value: data.at_user.id,
      },
      items: accTransDetail,
      release: data.at_rls ? data.at_rls : [],
    });

    switch (type) {
      case "detail":
        toggleDetail();
        break;
      case "detail-expense":
        toggleDetailExpense();
        break;
      case "payment":
        toggle();
        break;
      case "approve":
        setIsEdit(true);
        setIsApprove(true);
        setIsRelease(false);
        toggle();
        break;
      case "release":
        setIsEdit(true);
        setIsRelease(true);
        setIsApprove(false);
        toggle();
        break;
      case "copy":
        setIsEdit(false);
        setIsApprove(false);
        setIsRelease(false);
        toggle();
        break;
      default:
        setIsEdit(true);
        setIsApprove(false);
        setIsRelease(false);
        toggle();
        break;
    }
  },
    [toggle, userType],
  );

  function getType(type) {
    let transType;
    switch (type) {
      case "CASH IN":
        transType = { label: "PENERIMAAN CASH", value: "CASH IN" };
        break;
      case "CASH OUT":
        transType = { label: "PENGELUARAN CASH", value: "CASH OUT" };
        break;
      case "RECEIVABLE":
        transType = { label: "PIUTANG", value: "RECEIVABLE" };
        break;
      case "PAYABLE":
        transType = { label: "HUTANG", value: "PAYABLE" };
        break;
      default:
        transType = { label: "OTHER", value: "OTHER" };
        break;
    }
    return transType;
  }

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = accTransList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAccTransList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      const data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0 mb-2">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = accTransList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setAccTransList(updatedData);
            }}
          />
          <div>
            <ButtonGroup>
              <UncontrolledButtonDropdown>
                <Button
                  color="light"
                  className="btn-sm"
                  onClick={() => {
                    setInfo(data);
                    handleAccTransClick(data, "detail");
                  }}
                >
                  <i className="ri-printer-line text-info fs-15"></i>
                </Button>

                {userRole && (data.statusId === 1 || userType === "admin" || userType === "client" || userType === "company" || userRole.split(",").indexOf("updateAccTransactionx") === -1 || userRole.split(",").indexOf("journalAccTransaction") === -1) && (
                  <Button
                    color="light"
                    className={"btn-sm"}
                    onClick={() => {
                      setInfo(data);
                      handleAccTransClick(data);
                    }}>
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                )}

                {userRole && (data.statusId === 1 || userType === "admin" || userType === "client" || userType === "company" || userRole.split(",").indexOf("updateAccTransactionx") === -1 || userRole.split(",").indexOf("journalAccTransaction") === -1) && (
                  <Button
                    color="light"
                    className={"btn-sm"}
                    onClick={() => {
                      setInfo(data);
                      handleAccTransClick(data, "copy");
                    }}>
                    <i className="ri-file-copy-line fs-15"></i>
                  </Button>
                )}
                {userRole && (data.statusId === 1 || userType === "admin" || userType === "client" || userType === "company" || userRole.split(",").indexOf("deleteAccTransaction") === -1) && (
                  <Button
                    className={"btn-sm"}
                    color="light"
                    onClick={() => {
                      data.statusId = 4;
                      onClickDelete(data);
                    }}>
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                )}
                <DropdownToggle tag="button" className="btn btn-sm btn-light" split></DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={() => {
                      setInfo(data);
                      handleAccTransClick(data, "detail");
                    }}>
                    PRINT TRANSAKSI
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      setInfo(data);
                      toggleDetailExpense();
                    }}>
                    PRINT RO
                  </DropdownItem>
                </DropdownMenu>

                {data.statusId === 1 && !data.approval && data?.at_rls?.length === 0 && (
                  <button
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-sm btn-soft-success" : userRole && userRole.split(",").indexOf("approveAccTransaction") !== -1 ? "btn btn-sm btn-soft-success" : "d-none"}
                    onClick={() => {
                      setInfo(data);
                      handleAccTransClick(data, "approve");
                      //toggleApprove();
                    }}>
                    APPROVE
                  </button>
                )}

                {/* {data.statusId === 2 && data.approval && (
                  <button
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-sm btn-soft-info" : userRole && userRole.split(",").indexOf("releaseAccTransaction") !== -1 ? "btn btn-sm btn-soft-info" : "d-none"}
                    onClick={() => {
                      setInfo(data);
                      handleAccTransClick(data, "release");
                      //toggleApprove();
                    }}>
                    RELEASE
                  </button>
                )} */}

                {/* {data.statusId===3 && (data.type === "PAYABLE" || data.type === "RECEIVABLE") && !data.purchaseId && !data.civilContractId && parseFloat(data.paid_amount || 0) < parseFloat(data.amount || 0) && (
                  <button
                    className={userType === "admin" || userType === "client" ? "btn btn-sm btn-soft-info" : "d-none"}
                    onClick={() => {
                      setInfo(data);
                      handleAccTransClick(data, "payment");
                    }}>
                    PELUNASAN
                  </button>
                )} */}
              </UncontrolledButtonDropdown>
            </ButtonGroup>
          </div>
        </div>
      );
    },
  },
  {
    Header: "Transaksi",
    accessor: "at_status.name",
    filterable: true,
    Cell: (cell) => {
      const data = cell.row.original;
      let stat;
      let statName = data.at_status?.name;
      switch (statName) {
        case "DRAFT":
          stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
          break;
        case "APPROVED":
          stat = <span className="badge text-uppercase badge-soft-success">APPROVED</span>;
          break;
        case "RELEASED":
          stat = <span className="badge text-uppercase badge-soft-info">RELEASED</span>;
          break;
        case "CANCELLED":
          stat = <span className="badge text-uppercase badge-soft-danger">CANCELED</span>;
          break;
        default:
          stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
          break;
      }
      let type;
      switch (data.type) {
        case "CASH IN":
          type = <span className="badge text-uppercase badge-soft-success">{data.type}</span>;
          break;
        case "CASH OUT":
          type = <span className="badge text-uppercase badge-soft-warning">{data.type}</span>;
          break;
        case "RECEIVABLE":
          type = <span className="badge text-uppercase badge-soft-info">{data.type}</span>;
          break;
        case "PAYABLE":
          type = <span className="badge text-uppercase badge-soft-danger">{data.type}</span>;
          break;
        default:
          type = <span className="badge text-uppercase badge-soft-primary">{data.type}</span>;
          break;
      }
      return (
        <div className="cursor-pointer" onClick={() => setInfo(data)}>
          <div className="mb-1">
            <Link to="#" className="fw-semibold">
              {data.transaction_no}
            </Link>
          </div>
          <div className="mb-2">{handleValidDate(data.transactionat, "DD/MM/YYYY")}</div>
          <div className="hstack gap-2">
            {type}
            {stat}
          </div>
        </div>
      );
    },
  },
  {
    id: "No_Transaksi",
    Header: "No Transaksi",
    accessor: "transaction_no",
    filterable: true,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <Link
          to="#"
          className="fw-semibold"
          onClick={() => {
            handleAccTransClick(data);
          }}>
          {data.transaction_no}
        </Link>
      );
    },
  },
  {
    id: "Nilai",
    Header: <div className="text-end pe-3">Nilai</div>,
    accessor: "amount",
    filterable: true,
    Cell: (cellProps) => {
      const data = cellProps.row.original;
      return (
        <div className="cursor-pointer text-end px-2" onClick={() => setInfo(data)}>
          <span className="fw-semibold fs-15">{currencyFormat(data.amount)}</span>
          {(data.type === "PAYABLE" || data.type === "RECEIVABLE") && !data.purchaseId && !data.civilContractId && parseFloat(data.paid_amount || 0) < parseFloat(data.amount || 0) && <div className="text-danger fs-11"> - {currencyFormat(parseFloat(data.amount || 0) - parseFloat(data.paid_amount || 0))}</div>}
        </div>
      );
    },
  },
  {
    id: "Tanggal",
    Header: "Tanggal",
    accessor: (data) => <div className="cursor-pointer" onClick={() => setInfo(data)}>{handleValidDate(data.transactionat, "DD/MM/YYYY")}</div>,
    filterable: true,
  },
  {
    Header: "Keterangan",
    accessor: "description",
    filterable: true,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="cursor-pointer" onClick={() => setInfo(data)}>
          <div className="text-break mb-0 fw-semibold">
            {data.at_branch ? data.at_branch.name : "-"}
            {data.statusId === 1 && data.approval && (
              <span className="badge text-uppercase ms-2 badge-soft-danger">
                <i className="ri-close-circle-line text-danger me-1 align-bottom fs-10"></i> Approval Khusus
              </span>
            )}
            {(data?.at_detail?.length === 0 || parseFloat(data?.at_detail[0]?.accId || 0) === 0) && (
              <span className="badge ms-2 text-uppercase badge-soft-danger">
                <i className="ri-close-circle-line text-danger me-1 align-bottom fs-10"></i> Jurnal
              </span>
            )}
            {!data.budgetId && (
              <span className="badge ms-2 text-uppercase badge-soft-danger">
                <i className="ri-close-circle-line text-danger me-1 align-bottom fs-10"></i> Cashflow
              </span>
            )}
          </div>
          <div className="text-break mb-0 fw-semibold">DEPT. {data.at_department ? data.at_department.name : "-"}</div>
          {(data.at_cvl_budget || data.at_cvl_account || data.at_cvl) && (
            <div className="mb-0 text-break ">
              <span className="fw-semibold">{data?.at_cvl?.name}</span> - {data?.at_cvl_account?.name}
            </div>
          )}
          {data.at_purchase && data.at_purchase.purchase_detail && data.at_purchase.purchase_detail[0] && data.at_purchase.purchase_detail[0].purchase_cvl && (
            <div className="mb-0 text-break ">
              <span className="fw-semibold">{data.at_purchase.purchase_detail[0].purchase_cvl?.name}</span> - {data.at_purchase.purchase_detail[0].purchase_cvl_account?.name}
            </div>
          )}
          {data.at_purchase && <div className="mb-0 text-break ">No Tx Pembelian : {data.at_purchase.transaction_no}</div>}
          {data.at_sales && <div className="mb-0 text-break ">No Tx Penjualan : {data.at_sales.transaction_no}</div>}
          <div className="mb-0 text-break">{data.description}</div>
        </div>
      );
    },
  },
  {
    id: "RAB",
    Header: "RAB",
    accessor: (data) => (data.at_cvl_budget || data.at_cvl_account || data.at_cvl ? data?.at_cvl?.name + " " + data?.at_cvl_account?.name : data?.at_purchase && data?.at_purchase.purchase_detail && data.at_purchase.purchase_detail[0] && data.at_purchase.purchase_detail[0].purchase_cvl ? data.at_purchase.purchase_detail[0].purchase_cvl?.name + " " + data.at_purchase.purchase_detail[0].purchase_cvl_account?.name : ""),
    filterable: true,
  },
  {
    id: "purchase",
    Header: "Purchase",
    accessor: "at_purchase.transaction_no",
    filterable: true,
  },
  {
    id: "sales",
    Header: "Sales",
    accessor: "at_sales.transaction_no",
    filterable: true,
  },
  {
    id: "department",
    Header: "Departemen",
    accessor: "at_department.name",
    filterable: true,
  },
  {
    id: "branch",
    Header: "Branch",
    accessor: "at_branch.name",
    filterable: true,
  },
  {
    id: "createdby",
    Header: "Created by",
    accessor: "at_createdby.name",
    filterable: true,
  },
  {
    id: "type",
    Header: "Type",
    accessor: "type",
    filterable: true,
  }], [accTransList, handleAccTransClick, toggleApprove, toggleHistory, userType, userRole, isCheckAll]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = accTransList.map((item) => ({
      ...item,
      isChecked: false,
    }));

    setAccTransList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => accTransList, [accTransList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["type", "branch", "sales", "purchase", "No_Transaksi", "department", "Tanggal", "createdby", "RAB"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      departmentId: searchDepartment.value ?? "",
      branchId: branchSelected?.value ?? "",
      companyId: companySelected?.value ?? "",
      budgetId: searchBudget.value ?? "",
      accId: filterAcc?.value ?? "",
    };
    dispatch(onGetAccTranss(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchValue("");
    setSearchDepartment("");
    setSearchBudget("");
    setFilterAcc("");
    handleGetAccTrans(companySelected?.value, branchSelected?.value);
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (info) {
        info.statusId = 2;
        info.setApprove = true;
        info.approval_note = values.approval_note;
        dispatch(onUpdateAccTrans(info));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAccTrans(element.value));
    });
    checkall.checked = false;
  };

  function handleAccTransDetailAdd() {
    let obj = {
      itemId: 0,
      isPrimary: false,
      description: "",
      sort_order: validation.values.items.length + 1,
      debit: 0,
      credit: 0,
      accId: "",
      acc: "",
    };

    validation.setFieldValue("items", [...validation.values.items, obj]);
  }

  const onClickDeleteDetailItem = (index) => {
    validation.values.items.splice(index, 1);
    validation.setFieldValue("items", validation.values.items);
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = docImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setDocImg(newState);
    } else {
      const index = docImg.findIndex((fl) => fl.filename === file.filename);
      setDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };
  const handleSelectFile = (file) => {
    setDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (accTrans && accTrans.id) || 0,
      company: (accTrans && accTrans.company) || companySelected,
      branch: (accTrans && accTrans.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      client: (accTrans && accTrans.client) || clientSelected,
      approval: (accTrans && accTrans.approval) || false,
      type: accTrans && accTrans.type ? accTrans.type : { label: "HUTANG", value: "PAYABLE" },
      transactionat: (accTrans && accTrans.transactionat) ?? "",
      department: (accTrans && accTrans.department) ?? "",
      paid_amount: (accTrans && accTrans.paid_amount) || 0,
      cvl_budget: (accTrans && accTrans.cvl_budget) ?? "",
      paymentMethod: (accTrans && accTrans.paymentMethod) ?? "",
      tag: (accTrans && accTrans.tag) ?? "",
      sales: (accTrans && accTrans.sales) ?? "",
      purchase: (accTrans && accTrans.purchase) ?? "",
      legal: (accTrans && accTrans.legal) ?? "",
      legal_asset: (accTrans && accTrans.legal_asset) ?? "",
      legal_master: (accTrans && accTrans.legal_master) ?? "",
      legal_permission: (accTrans && accTrans.legal_permission) ?? "",
      legal_fraction: (accTrans && accTrans.legal_fraction) ?? "",
      civilContract: (accTrans && accTrans.civilContract) ?? "",
      amount: (accTrans && accTrans.amount) || 0,
      description: (accTrans && accTrans.description) ?? "",
      user: (accTrans && accTrans.user) ?? "",
      items: (accTrans && accTrans.items) ?? "",
      release: (accTrans && accTrans.release) ?? "",
      budget: (accTrans && accTrans.budget) ?? "",
    },
    validationSchema: Yup.object({
      transactionat: Yup.string().required("Please Pick Transaction Date"),
      amount: Yup.string().required("Silahkan isi Jumlah Transaksi"),
      type: Yup.object().required("Please Select Warehouse").nullable(true),
      company: Yup.object().required("Please Select company").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      branch: Yup.object().required("Silahkan isi Proyek / Cabang").nullable(true),
      //department: Yup.object().required("Silahkan isi Department").nullable(true),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        let editSubmit = {
          id: values.id,
          statusId: isApprove ? 3 : isRelease ? 3 : accTrans?.statusId,
          isRelease: isRelease,
          isApprove: isApprove,
          approval: values.approval,
          accTransPaymentId: accTrans.accTransPaymentId,
          userId: values.user.value,
          type: values.type.value,
          transactionat: values.transactionat,
          paymentMethodId: values.paymentMethod.value,
          description: values.description,
          clientId: values.client.value,
          budgetId: values.budget.value,
          tagId: values.tag.value,
          companyId: values.company.value,
          departmentId: values.department.value,
          branchId: values.branch.value,
          salesId: values.sales.value,
          legalId: values.legal.type === "inventory" ? values.legal.value : values.legal_asset.value,
          legalMasterId: values.legal_master.value,
          legalPermissionId: values.legal_permission.value,
          legalFractionalId: values.legal_fraction.value,
          civilContractId: values.civilContract.value,
          purchaseId: values.purchase.value,
          civilAccountId: values.cvl_budget.civilAccountId || null,
          civilBudgetId: values.cvl_budget.civilBudgetId || null,
          civilBudgetDetailId: values.cvl_budget.civilBudgetDetailId || null,
          amount: values.amount,
          paid_amount: values.paid_amount,
          at_detail: JSON.stringify(values.items),
          at_rls: JSON.stringify(values.release),
          files: docImg.length > 0 ? docImg : [],
        };
        dispatch(onUpdateAccTrans(editSubmit));
      } else {
        let addSubmit = {
          accTransPaymentId: accTrans?.accTransPaymentId,
          userId: values.user.value,
          type: values.type.value,
          approval: values.approval,
          transactionat: values.transactionat,
          paymentMethodId: values.paymentMethod.value,
          description: values.description,
          clientId: values.client.value,
          budgetId: values.budget.value,
          tagId: values.tag.value,
          companyId: values.company.value,
          departmentId: values.department.value,
          branchId: values.branch.value,
          salesId: values.sales.value,
          purchaseId: values.purchase.value,
          legalId: values.legal.type === "inventory" ? values.legal.value : values.legal_asset.value,
          legalMasterId: values.legal_master.value,
          legalPermissionId: values.legal_permission.value,
          legalFractionalId: values.legal_fraction.value,
          civilContractId: values.civilContract.value,
          civilAccountId: values.cvl_budget.civilAccountId || null,
          civilBudgetId: values.cvl_budget.civilBudgetId || null,
          civilBudgetDetailId: values.cvl_budget.civilBudgetDetailId || null,
          amount: values.amount,
          paid_amount: values.paid_amount,
          at_detail: JSON.stringify(values.items),
          at_rls: JSON.stringify(values.release),
          files: docImg.length > 0 ? docImg : [],
        };
        dispatch(onAddNewAccTrans(addSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");
    final = final.replace(/^Satu Juta\b/, "Sejuta");
    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  const calcWrong = () => {
    let data = 0;
    accTranss.filter(f => f.type === 'CASH OUT' && f.statusId !== 4 && f?.at_rls?.length).forEach(element => {
      let arr = [];
      (element.at_rls || []).forEach((o, i) => {
        if (o?.type === "Keuangan") {
          const hasArr = arr.includes(o?.at_rls_trx?.at_cvl?.type);
          if (!hasArr)
            arr.push(o?.at_rls_trx?.at_cvl?.type);
        }

        if (o?.type === "SPK") {
          const hasArr = arr.includes(o?.at_rls_contract?.cvl_contract_cvl_budget?.type);
          if (!hasArr)
            arr.push(o?.at_rls_contract?.cvl_contract_cvl_budget?.type);
        }

        if (o?.type === "Material") {
          (o?.at_rls_purchase?.purchase_detail || []).forEach(p => {
            const hasArr = arr.includes(p?.purchase_cvl_budget?.type);
            if (!hasArr)
              arr.push(p?.purchase_cvl_budget?.type);
          });
        }
      });

      let release_amount = (element.at_rls || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      let amount = element.amount;

      if (arr.length > 1 || (parseFloat(release_amount) !== parseFloat(amount)))
        data++;
    });
    return data;
  };

  document.title = "Transaksi | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={accTransList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAccTrans} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="DAFTAR TRANSAKSI KEUANGAN" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAccTransaction") !== -1 ? "btn btn-primary add-btn me-3" : "d-none"}
              id="create-btn"
              onClick={() => {
                validation.setFieldValue("legal", "");
                validation.setFieldValue("legal_asset", "");
                validation.setFieldValue("legal_master", "");
                validation.setFieldValue("legal_permission", "");
                validation.setFieldValue("legal_fraction", "");
                validation.setFieldValue("civilContract", "");
                validation.setFieldValue("purchase", "");
                validation.setFieldValue("sales", "");
                validation.setFieldValue("cvl_budget", "");

                setIsLegal(false);
                setIsPurchase(false);
                setIsSales(false);
                setIsBudget(false);
                setIsCivilContract(false);
                setIsEdit(false);
                setIsApprove(false);
                setIsRelease(false);

                setAccTrans(null);
                setDocImg([]);
                validation.resetForm();

                toggle();
              }}
            >
              <i className="ri-add-line me-1 align-bottom fs-12"></i>Tambah
            </button>
            <ExportDoc data={accTransDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col sm={12} className={userType === "admin" || userType === "client" || userType === "company" || (userRole && userRole.split(",").indexOf("viewAccTransaction") > 0) ? "" : "d-none"}>
            <div className="hstack gap-3">
              <div
                className="card align-items-center card-animate p-3"
                style={activeProgress === "all" ? { borderBottom: "3px solid #FFCC00", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleProgress("all");
                  gotoPage(0);
                  setPageIdx(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeProgress === "all" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{accTranss.length}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">SEMUA TRANSAKSI</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeProgress === "CASH OUT" ? { borderBottom: "3px solid #FFCC00", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleProgress("CASH OUT");
                  gotoPage(0);
                  setPageIdx(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeProgress === "CASH OUT" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{accTranss.filter((trans) => trans.type === "CASH OUT").length}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">PENGELUARAN KAS</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeProgress === "CASH IN" ? { borderBottom: "3px solid #FFCC00", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleProgress("CASH IN");
                  gotoPage(0);
                  setPageIdx(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeProgress === "CASH IN" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{accTranss.filter((trans) => trans.type === "CASH IN").length}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">PENERIMAAN KAS</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeProgress === "PAYABLE" ? { borderBottom: "3px solid #FFCC00", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleProgress("PAYABLE");
                  gotoPage(0);
                  setPageIdx(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeProgress === "PAYABLE" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{accTranss.filter((trans) => trans.type === "PAYABLE").length}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">HUTANG</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeProgress === "RECEIVABLE" ? { borderBottom: "3px solid #FFCC00", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleProgress("RECEIVABLE");
                  gotoPage(0);
                  setPageIdx(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeProgress === "RECEIVABLE" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{accTranss.filter((trans) => trans.type === "RECEIVABLE").length}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">PIUTANG</div>
                </div>
              </div>
              <div
                className="card align-items-center card-animate p-3"
                style={activeProgress === "OTHER" ? { borderBottom: "3px solid #FFCC00", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 5 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                onClick={() => {
                  toggleProgress("OTHER");
                  gotoPage(0);
                  setPageIdx(0);
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className={activeProgress === "OTHER" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{accTranss.filter((trans) => trans.type === "OTHER").length}</div>
                  </div>
                  <div className="col-auto fs-10 text-center flex-grow-1">LAINNYA</div>
                </div>
              </div>
            </div>
          </Col>

          <Col sm={12}>
            <Card>
              <CardBody className="pt-1 mb-0 pb-0">
                <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                  {/* <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("1", "all");
                        gotoPage(0);
                        setPageIdx(0);
                      }} href="#">
                      <i className="ri-file-list-3-line me-1 fs-13"></i> ALL
                    </NavLink>
                  </NavItem> */}
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("2", "JOURNAL");
                        gotoPage(0);
                        setPageIdx(0);
                      }}
                      href="#"
                    >
                      <i className="bx bx-time me-1 fs-13 fw-semibold"></i>JURNAL
                      <span className={(accTranss || []).filter((f) => (f?.at_detail?.length <= 1 || parseFloat(f?.at_detail[0]?.accId || 0) === 0) && f.statusId !== 4).length > 0 ? "ms-2 fs-10 badge rounded-pill bg-danger" : "ms-2 fs-10 badge rounded-pill bg-success"}>{(accTranss || []).filter((f) => (f?.at_detail?.length <= 1 || parseFloat(f?.at_detail[0]?.accId || 0) === 0) && f.statusId !== 4).length}</span>
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "99" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("99", "CASHFLOW");
                        gotoPage(0);
                        setPageIdx(0);
                      }}
                      href="#"
                    >
                      <i className="bx bx-time me-1 fs-13 fw-semibold"></i>CASHFLOW
                      <span className={(accTranss || []).filter((f) => !f.budgetId && f.statusId !== 4).length > 0 ? "ms-2 fs-10 badge rounded-pill bg-danger" : "ms-2 fs-10 badge rounded-pill bg-success"}>{(accTranss || []).filter((f) => !f.budgetId && f.statusId !== 4).length}</span>
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("3", "APPROVED CASHOUT");
                        gotoPage(0);
                        setPageIdx(0);
                      }}
                      href="#"
                    >
                      <i className="bx bx-time me-1 fs-13 fw-semibold"></i>RELEASE PEMBAYARAN
                      <span className={(accTranss || []).filter((f) => f?.statusId === 2 && f?.approval && f?.type === "CASH OUT").length > 0 ? "ms-2 fs-10 badge rounded-pill bg-danger" : "ms-2 fs-10 badge rounded-pill bg-success"}>{(accTranss || []).filter((f) => f?.statusId === 2 && f?.approval && f?.type === "CASH OUT").length}</span>
                    </NavLink>
                  </NavItem> */}
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("4", "DRAFT");
                        gotoPage(0);
                        setPageIdx(0);
                      }}
                      href="#"
                    >
                      <i className="bx bx-time me-1 fs-13 fw-semibold"></i>APPROVAL
                      <span className={(accTranss || []).filter((f) => f?.statusId === 1 && !f?.approval).length > 0 ? "ms-2 fs-10 badge rounded-pill bg-danger" : "ms-2 fs-10 badge rounded-pill bg-success"}>{(accTranss || []).filter((f) => f?.statusId === 1 && !f?.approval).length}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "8" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("8", "DOC");
                        gotoPage(0);
                        setPageIdx(0);
                      }}
                      href="#"
                    >
                      <i className="bx bx-time me-1 fs-13 fw-semibold"></i>UPLOAD BUKTI
                      <span className={(accTranss || []).filter((f) => (f?.at_file || []).length === 0 && f?.type === "CASH OUT" && f.statusId !== 4).length > 0 ? "ms-2 fs-10 badge rounded-pill bg-danger" : "ms-2 fs-10 badge rounded-pill bg-success"}>{(accTranss || []).filter((f) => (f?.at_file || []).length === 0 && f?.type === "CASH OUT").length}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "98" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("98", "CORRECTION");
                        gotoPage(0);
                        setPageIdx(0);
                      }}
                      href="#">
                      <i className="bx bx-time me-1 fs-13 fw-semibold"></i>KOREKSI PENGAJUAN
                      <span className={calcWrong() ? "ms-2 fs-10 badge rounded-pill bg-danger" : "ms-2 fs-10 badge rounded-pill bg-success"}>{calcWrong()}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "5" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("5", "RELEASED");
                        gotoPage(0);
                        setPageIdx(0);
                      }}
                      href="#"
                    >
                      <i className="ri-checkbox-circle-line text-info me-1 fs-13"></i>RELEASED
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "7" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("7", "CANCELED");
                        gotoPage(0);
                        setPageIdx(0);
                      }}
                      href="#"
                    >
                      <i className="ri-close-circle-line text-danger me-1 fs-13"></i>CANCELED
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "8" }, "fw-semibold")}
                      onClick={() => {
                        toggleTab("8", "PELUNASAN");
                        gotoPage(0);
                        setPageIdx(0);
                      }} href="#">
                      <i className="ri-checkbox-circle-line me-1 align-bottom fs-12"></i>PELUNASAN AP / AR
                    </NavLink>
                  </NavItem> */}
                </Nav>
                <div className="pt-3">
                  <Row>
                    <Col sm={1}>
                      <div className="me-2 mb-3 col-12">
                        <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                          {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                              {pageSize}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col sm={2}>
                      <div className="search-box me-2 mb-3 d-inline-block col-12">
                        <input
                          id="search-bar-0"
                          type="text"
                          className="form-control search"
                          onChange={(e) => {
                            setSearchValue(e.target.value);
                            onChange(e.target.value);
                            gotoPage(0);
                            setPageIdx(0);
                          }}
                          placeholder={`${countSearch} Cari...`}
                          value={searchValue ?? ""}
                        />
                        <i className="bx bx-search-alt search-icon"></i>
                      </div>
                    </Col>
                    <Col sm={2}>
                      <Select
                        name="searchDepartment"
                        value={searchDepartment}
                        placeholder="Filter Department"
                        onChange={(e) => {
                          setSearchDepartment(e);
                        }}
                        options={departmentList}
                      ></Select>
                    </Col>
                    <Col sm={2}>
                      <Select
                        name="searchBudget"
                        value={searchBudget}
                        placeholder="Filter Cashflow"
                        onChange={(e) => {
                          setSearchBudget(e);
                        }}
                        options={budgetList.length ? budgetList : [{ options: [{ label: "Pilih Cabang Terlebih Dahulu" }] }]}
                      ></Select>
                    </Col>
                    <Col sm={2}>
                      <Select
                        name="searchAcc"
                        value={filterAcc}
                        placeholder="Filter Akun"
                        onChange={(e) => {
                          setFilterAcc(e);
                        }}
                        options={accountingList}
                      ></Select>
                    </Col>
                    <Col sm={2}>
                      <div className="search-box me-2 mb-3 col-12">
                        <Flatpickr
                          className="form-control"
                          id="datepicker-publish-input"
                          placeholder="Pilih Tanggal"
                          options={{
                            mode: "range",
                            dateFormat: "Y/m/d",
                          }}
                          value={filterDate}
                          onChange={(selectedDates, dateStr) => {
                            setFilterDate(dateStr);
                          }}
                        />
                        <i className="bx bx-calendar-alt search-icon"></i>
                      </div>
                    </Col>
                    <Col sm={1}>
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                          onClick={() => {
                            handleFilter();
                          }}
                        >
                          <i className="ri-search-line align-bottom fs-16"></i>
                        </button>
                        <button
                          type="button"
                          className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                          onClick={() => {
                            handleResetFilter();
                          }}
                        >
                          <i className="mdi mdi-restore align-bottom fs-18"></i>
                        </button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col sm={8}>
            <Card>
              <CardBody className="pt-3 pb-0">
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTableProps()} className="align-middletable-nowrap">
                    <thead>
                      {headerGroups.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th {...column.getSortByToggleProps()} key={index}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr key={row.getRowProps().key}>
                            {row.cells.map((cell, index) => {
                              return (
                                <td {...cell.getCellProps()} key={index}>
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button
                        className="btn btn-light"
                        onClick={() => {
                          setPageIdx(pageIndex - 1);
                          previousPage();
                        }}
                        disabled={!canPreviousPage}
                      >
                        {"<"}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button
                        className="btn btn-light"
                        onClick={() => {
                          setPageIdx(pageIndex + 1);
                          nextPage();
                        }}
                        disabled={!canNextPage}
                      >
                        {">"}
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit && !!isApprove ? "APPROVE TRANSAKSI" : !!isEdit && !!isRelease ? "RELEASE PEMBAYARAN TRANSAKSI" : !!isEdit ? "EDIT TRANSAKSI" : "TAMBAH TRANSAKSI"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <CardBody className="border-bottom border-bottom-dashed p-3">
                        <Row>
                          <Col lg={7}>
                            <Row>
                              <div className="mb-3 col-lg-6">
                                <Select
                                  name="type"
                                  placeholder="Jenis Transaksi"
                                  value={validation.values.type}
                                  onChange={(e) => {
                                    // let arr = [{
                                    //   itemId: 0,
                                    //   isPrimary: true,
                                    //   description: "",
                                    //   sort_order: 1,
                                    //   debit: 0,
                                    //   credit: 0,
                                    //   accId: "",
                                    //   amount: 0,
                                    //   acc: ""
                                    // },
                                    // {
                                    //   itemId: 0,
                                    //   isPrimary: false,
                                    //   description: "",
                                    //   sort_order: 2,
                                    //   debit: 0,
                                    //   credit: 0,
                                    //   accId: "",
                                    //   amount: 0,
                                    //   acc: ""
                                    // }];
                                    validation.setFieldValue("type", e);
                                    //validation.setFieldValue("items", arr);
                                  }}
                                  options={transTypeData}
                                ></Select>
                                {validation.touched.type && validation.errors.type && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.type}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Flatpickr
                                  className="form-control"
                                  id="datepicker-publish-input"
                                  placeholder="Pilih Tanggal"
                                  options={{
                                    mode: "single",
                                    dateFormat: "Y/m/d",
                                  }}
                                  onChange={(selectedDates, dateStr) => {
                                    validation.setFieldValue("transactionat", dateStr);
                                  }}
                                  value={validation.values.transactionat ?? ""}
                                />
                                {validation.touched.transactionat && validation.errors.transactionat && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.transactionat}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Select
                                  name="user"
                                  value={validation.values.user}
                                  placeholder="Pilih Kontak"
                                  onChange={(e) => {
                                    validation.setFieldValue("user", e);
                                  }}
                                  options={userList}
                                ></Select>
                                {validation.touched.user && validation.errors.user && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.user}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <div className="position-relative">
                                  <Select
                                    name="department"
                                    value={validation.values.department}
                                    placeholder="Pilih Departemen"
                                    onChange={(e) => {
                                      validation.setFieldValue("department", e);
                                    }}
                                    options={departmentList}
                                  ></Select>
                                  <div
                                    className="position-absolute"
                                    style={{
                                      top: "12px",
                                      left: "-24px",
                                    }}
                                  >
                                    {departmentLoading && (
                                      <Spinner color="primary" size="sm">
                                        Loading...
                                      </Spinner>
                                    )}
                                  </div>
                                </div>
                                {validation.touched.department && validation.errors.department && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.department}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Select
                                  name="branch"
                                  placeholder="Pilih Cabang"
                                  value={validation.values.branch}
                                  onChange={(e) => {
                                    validation.setFieldValue("branch", e);
                                    handleGetCivilBudget(companySelected.value, e.value);
                                    setBranchIdSelected(e.value);
                                    handleGetBudget(companySelected.value, e.value);
                                  }}
                                  options={branchList}
                                ></Select>
                                {validation.touched.branch && validation.errors.branch && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.branch}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Select
                                  name="budget"
                                  value={validation.values.budget}
                                  placeholder="Pilih Cashflow"
                                  onChange={(e) => {
                                    validation.setFieldValue("budget", e);
                                  }}
                                  options={budgetList}
                                ></Select>
                                {validation.touched.budget && validation.errors.budget && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.budget}
                                  </small>
                                )}
                              </div>
                              <div>
                                <div className="mb-3">
                                  <div className={"form-check form-switch form-switch-success"} dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm4"
                                      checked={isLegal}
                                      onChange={(e) => {
                                        setIsLegal(e.target.checked);
                                        if (e.target.checked === true) {
                                          if (accTrans && accTrans.legal) validation.setFieldValue("legal", accTrans.legal);
                                          if (accTrans && accTrans.legal_asset) validation.setFieldValue("legal_asset", accTrans.legal_asset);
                                          if (accTrans && accTrans.legal_master) validation.setFieldValue("legal_master", accTrans.legal_master);
                                          if (accTrans && accTrans.legal_permission) validation.setFieldValue("legal_permission", accTrans.legal_permission);
                                          if (accTrans && accTrans.legal_fraction) validation.setFieldValue("legal", accTrans.legal_fraction);
                                        } else {
                                          validation.setFieldValue("legal", "");
                                          validation.setFieldValue("legal_asset", "");
                                          validation.setFieldValue("legal_master", "");
                                          validation.setFieldValue("legal_permission", "");
                                          validation.setFieldValue("legal_fraction", "");
                                        }

                                        setIsCivilContract(false);
                                        setIsPurchase(false);
                                        setIsSales(false);
                                        setIsBudget(false);
                                        validation.setFieldValue("civilContract", "");
                                        validation.setFieldValue("purchase", "");
                                        validation.setFieldValue("sales", "");
                                        validation.setFieldValue("cvl_budget", "");
                                        handleGetLegal(validation.values.company.value);
                                        handleGetLegalFraction(validation.values.company.value, validation.values.branch.value);
                                        handleGetLegalMaster(validation.values.company.value, validation.values.branch.value);
                                        handleGetLegalPermisson(validation.values.company.value, validation.values.branch.value);
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm4">
                                      Transaksi terkait dengan Pertanahan / Perizinan?
                                      {(legalFractionLoading || legalMasterLoading || legalPermissionLoading || legalLoading) && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <div className={isBudget ? "d-none" : "row"}>
                                    <div className="col-lg-6">
                                      <Select
                                        name="legal"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validation.values.legal}
                                        placeholder="Pilih SPH"
                                        onChange={(e) => {
                                          validation.setFieldValue("legal", e);
                                          validation.setFieldValue("legal_asset", "");
                                          validation.setFieldValue("legal_master", "");
                                          validation.setFieldValue("legal_permission", "");
                                          validation.setFieldValue("legal_fraction", "");
                                        }}
                                        options={legalList}
                                      ></Select>
                                    </div>
                                    <div className="col-lg-6">
                                      <Select
                                        name="legal_asset"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validation.values.legal_asset}
                                        placeholder="Pilih Tanah Asset"
                                        onChange={(e) => {
                                          validation.setFieldValue("legal", "");
                                          validation.setFieldValue("legal_asset", e);
                                          validation.setFieldValue("legal_master", "");
                                          validation.setFieldValue("legal_permission", "");
                                          validation.setFieldValue("legal_fraction", "");
                                        }}
                                        options={legalAssetList}
                                      ></Select>
                                    </div>
                                    <div className="col-lg-6">
                                      <Select
                                        name="legal_master"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validation.values.legal_master}
                                        placeholder="Pilih Sertifikat Induk"
                                        onChange={(e) => {
                                          validation.setFieldValue("legal", "");
                                          validation.setFieldValue("legal_asset", "");
                                          validation.setFieldValue("legal_master", e);
                                          validation.setFieldValue("legal_permission", "");
                                          validation.setFieldValue("legal_fraction", "");
                                        }}
                                        options={legalMasterList}
                                      ></Select>
                                    </div>
                                    <div className="col-lg-6">
                                      <Select
                                        name="legal_permission"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validation.values.legal_permission}
                                        placeholder="Pilih Perizinan"
                                        onChange={(e) => {
                                          validation.setFieldValue("legal", "");
                                          validation.setFieldValue("legal_asset", "");
                                          validation.setFieldValue("legal_master", "");
                                          validation.setFieldValue("legal_permission", e);
                                          validation.setFieldValue("legal_fraction", "");
                                        }}
                                        options={legalPermissionList}
                                      ></Select>
                                    </div>
                                    <div className="col-lg-6 d-none">
                                      <Select
                                        name="legal_fraction"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validation.values.legal_fraction}
                                        placeholder="Pilih Sertifikat Pecahan"
                                        onChange={(e) => {
                                          validation.setFieldValue("legal", "");
                                          validation.setFieldValue("legal_asset", "");
                                          validation.setFieldValue("legal_master", "");
                                          validation.setFieldValue("legal_permission", "");
                                          validation.setFieldValue("legal_fraction", e);
                                        }}
                                        options={legalFractionList}
                                      ></Select>
                                    </div>
                                  </div>
                                </div>
                                <div className={"mb-3"}>
                                  <div className="form-check form-switch form-switch-success" dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm1"
                                      checked={isBudget}
                                      onChange={(e) => {
                                        handleGetCivilBudget(validation.values.company.value, validation.values.branch.value);
                                        setIsBudget(e.target.checked);
                                        if (e.target.checked === false) {
                                          validation.setFieldValue("cvl_budget", "");
                                        }

                                        validation.setFieldValue("legal", "");
                                        validation.setFieldValue("legal_asset", "");
                                        validation.setFieldValue("legal_master", "");
                                        validation.setFieldValue("legal_permission", "");
                                        validation.setFieldValue("legal_fraction", "");
                                        setIsLegal(false);
                                        setIsSales(false);
                                        validation.setFieldValue("sales", "");
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm1">
                                      Transaksi terkait dengan RAB ?
                                      {civilBudgetLoading && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <Select
                                    name="cvl_budget"
                                    className={isBudget ? "mt-2" : "mt-2 d-none"}
                                    value={validation.values.cvl_budget}
                                    placeholder="Pilih Item Anggaran Teknik Terkait"
                                    onChange={(e) => {
                                      validation.setFieldValue("cvl_budget", e);
                                    }}
                                    options={civilBudgetDetailList}
                                  ></Select>
                                </div>
                                <div className={"mb-3"}>
                                  <div className="form-check form-switch form-switch-success" dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm5"
                                      checked={isCivilContract}
                                      onChange={(e) => {
                                        setIsCivilContract(e.target.checked);
                                        if (e.target.checked === true) {
                                          if (accTrans && accTrans.civilContract) {
                                            validation.setFieldValue("civilContract", accTrans.civilContract);
                                          }
                                        } else {
                                          validation.setFieldValue("civilContract", "");
                                        }

                                        setIsLegal(false);
                                        setIsPurchase(false);
                                        setIsSales(false);
                                        setIsBudget(false);
                                        validation.setFieldValue("legal", "");
                                        validation.setFieldValue("legal_asset", "");
                                        validation.setFieldValue("legal_master", "");
                                        validation.setFieldValue("legal_permission", "");
                                        validation.setFieldValue("legal_fraction", "");
                                        validation.setFieldValue("purchase", "");
                                        validation.setFieldValue("sales", "");
                                        handleGetCivilContract(validation.values.company.value, validation.values.branch.value);
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm5">
                                      Transaksi terkait dengan SPK?{" "}
                                      {civilContractLoading && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <Select
                                    name="civilContract"
                                    className={isCivilContract ? "mt-3" : "mt-3 d-none"}
                                    value={validation.values.civilContract}
                                    placeholder="Pilih SPK Terkait"
                                    onChange={(e) => {
                                      validation.setFieldValue("civilContract", e);
                                    }}
                                    options={civilContractList}
                                  ></Select>
                                </div>
                                <div className={"mb-3"}>
                                  <div className="form-check form-switch form-switch-success" dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm3"
                                      checked={isPurchase}
                                      onChange={(e) => {
                                        setIsPurchase(e.target.checked);
                                        if (e.target.checked === true) {
                                          if (accTrans && accTrans.purchase) {
                                            validation.setFieldValue("purchase", accTrans.purchase);
                                          }
                                        } else {
                                          validation.setFieldValue("purchase", "");
                                        }
                                        setIsSales(false);
                                        validation.setFieldValue("sales", "");
                                        setIsCivilContract(false);
                                        validation.setFieldValue("civilContract", "");
                                        setIsLegal(false);
                                        validation.setFieldValue("legal", "");
                                        validation.setFieldValue("legal_asset", "");
                                        validation.setFieldValue("legal_master", "");
                                        validation.setFieldValue("legal_permission", "");
                                        validation.setFieldValue("legal_fraction", "");
                                        handleGetPurchase(validation.values.company.value, validation.values.branch.value);
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm3">
                                      Transaksi terkait dengan Pembelian?
                                      {purchaseLoading && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <Select
                                    name="purchase"
                                    className={isPurchase ? "mt-3" : "mt-3 d-none"}
                                    value={validation.values.purchase}
                                    placeholder="Pilih Transaksi Pembelian Terkait"
                                    onChange={(e) => {
                                      validation.setFieldValue("purchase", e);
                                    }}
                                    options={purchaseList}
                                  ></Select>
                                </div>
                                <div className={"mb-3"}>
                                  <div className="form-check form-switch form-switch-success" dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm2"
                                      checked={isSales}
                                      onChange={(e) => {
                                        setIsSales(e.target.checked);
                                        if (e.target.checked === true) {
                                          if (accTrans && accTrans.sales) {
                                            validation.setFieldValue("sales", accTrans.sales);
                                          }
                                        } else {
                                          validation.setFieldValue("sales", "");
                                        }
                                        setIsLegal(false);
                                        validation.setFieldValue("legal", "");
                                        validation.setFieldValue("legal_asset", "");
                                        validation.setFieldValue("legal_master", "");
                                        validation.setFieldValue("legal_permission", "");
                                        validation.setFieldValue("legal_fraction", "");
                                        setIsPurchase(false);
                                        validation.setFieldValue("purchase", "");
                                        setIsCivilContract(false);
                                        validation.setFieldValue("civilContract", "");
                                        setIsBudget(false);
                                        validation.setFieldValue("cvl_budget", "");
                                        handleGetSales(validation.values.company.value, validation.values.branch.value);
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm2">
                                      Transaksi terkait dengan Penjualan?{" "}
                                      {salesLoading && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <Select
                                    name="sales"
                                    className={isSales ? "mt-3" : "mt-3 d-none"}
                                    value={validation.values.sales}
                                    placeholder="Pilih Transaksi Penjualan Terkait"
                                    onChange={(e) => {
                                      validation.setFieldValue("sales", e);
                                    }}
                                    options={salesList}
                                  ></Select>
                                </div>
                              </div>
                              <div className="mb-3">
                                <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan (jika ada)" name="description" rows={validation.values.release.length ? 5 : 2} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                              </div>
                            </Row>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="client"
                                  value={validation.values.client}
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  placeholder="Pilih Grup Usaha"
                                  onChange={(e) => {
                                    dispatch(setClientSelect(e));
                                    validation.setFieldValue("client", e);
                                  }}
                                  options={clientList}
                                ></Select>
                                <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                  {clientLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.client && validation.errors.client && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.client}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="company"
                                  value={validation.values.company}
                                  placeholder="Pilih Perusahaan"
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  onChange={(e) => {
                                    dispatch(setCompanySelect(e));
                                    setAccountingList([]);
                                    setUserList([]);
                                    setTaxList([]);
                                    setDepartmentList([]);
                                    setCivilBudgetDetailList([]);
                                    setPaymentMethodList([]);
                                    setBranchList([]);
                                    validation.resetForm({});
                                    validation.setFieldValue("company", e);
                                    handleGetAccTrans(companySelected.value, branchSelected.value);
                                  }}
                                  options={companyList}
                                ></Select>
                                <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                  {companyLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.company && validation.errors.company && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.company}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <Select
                                name="tag"
                                value={validation.values.tag}
                                placeholder="Pilih Tag"
                                onChange={(e) => {
                                  validation.setFieldValue("tag", e);
                                  setAccTag(e.value)
                                }}
                                options={tagList}
                              ></Select>
                              {validation.touched.tag && validation.errors.tag && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.tag}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <CurrencyInput
                                disabled={(accTrans?.approval || accTrans?.statusId === 3) && userType !== "admin" && isEdit ? true : false}
                                id="amount"
                                name="amount"
                                prefix="Rp. "
                                style={{ border: "1px solid #ccc", width: "100%" }}
                                className="form-control-lg fw-semibold"
                                placeholder="Input Nilai Transaksi"
                                value={validation.values.amount}
                                decimalsLimit={2}
                                onFocus={(e) => e.target.select()}
                                onValueChange={(value, name, values) => {
                                  validation.setFieldValue("amount", value);
                                  (validation.values.items || []).forEach((e, i) => {
                                    if (e.debit > 0) validation.values.items[i].debit = value;
                                    if (e.credit > 0) validation.values.items[i].credit = value;
                                  })
                                  validation.setFieldValue("items", validation.values.items);
                                }}
                              />
                              {validation.touched.amount && validation.errors.amount && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.amount}
                                </p>
                              )}
                            </div>
                            {userType === "admin" && (
                              <div className="mb-3">
                                <CurrencyInput id="paid_amount" name="paid_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control-lg fw-semibold" placeholder="Input Nilai Transaksi" value={validation.values.paid_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validation.setFieldValue("paid_amount", value)} />
                                {validation.touched.paid_amount && validation.errors.paid_amount && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.paid_amount}
                                  </p>
                                )}
                              </div>
                            )}
                            {validation?.values?.type?.value === "CASH OUT" && (
                              <div className="mb-1">
                                <Input name="approval" id="approval-field" className={validation?.values?.approval && userType !== "admin" ? "d-none" : "form-check-input"} type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.approval} /> &nbsp;
                                <Label htmlFor="approval-field" className="form-label text-danger">
                                  {validation?.values?.approval && userType !== "admin" && isEdit ? "Transaksi ini Memerlukan Approval Khusus Di Pengajuan Dana!" : "Memerlukan Approval Khusus Di Pengajuan Dana?"}
                                </Label>
                              </div>
                            )}
                            <div>
                              <div className="mt-3 d-flex justify-content-between">
                                <Label htmlFor="education" className="form-label">
                                  Bukti Transaksi
                                </Label>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-label btn-soft-success"
                                  onClick={() => {
                                    // setMediaType("other");
                                    toggleMedia();
                                  }}
                                >
                                  <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i>Media
                                </button>
                              </div>
                              {docImg.map((f, i) => {
                                if (f.isDeleted) {
                                  return null;
                                } else {
                                  return (
                                    <div key={i} className="border-bottom mb-3">
                                      <div className="d-flex justify-content-between mb-3 align-items-center">
                                        <div className="me-2">
                                          {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                            <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                          ) : (
                                            <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                              <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                            </Link>
                                          )}
                                        </div>
                                        <div className="text-truncate">{f.originalname}</div>
                                        <div>
                                          <Link
                                            to="#"
                                            className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                            onClick={(e) => {
                                              handleDeleteFile(f);
                                            }}
                                          >
                                            <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      {(validation.values.release || []).length ? (
                        <CardBody className="p-3 border-top border-top-dashed position-relative">
                          <div>
                            <h5>Detail Pengajuan Dana</h5>
                            <Table className="invoice-table table-borderless table-nowrap mb-0">
                              <thead className="align-middle">
                                <tr className="table-active">
                                  <th scope="col" style={{ width: "20px" }}>
                                    #
                                  </th>
                                  <th scope="col">Supplier / Kontak</th>
                                  <th scope="col">Type</th>
                                  <th scope="col">RAB</th>
                                  <th scope="col">No Transaksi</th>
                                  <th scope="col">No Invoice</th>
                                  <th scope="col">Jumlah Bayar</th>
                                </tr>
                              </thead>
                              <tbody id="newlink">
                                <tr>
                                  <th></th>
                                  <th colSpan={5}>
                                    Total <em className="fs-11 text-muted fw-normal">jumlah pengajuan harus sama dengan nilai transaksi</em>
                                  </th>
                                  <th className="text-info fs-14">{currencyFormat((info.at_rls || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}</th>
                                </tr>
                                {(info.at_rls || [])
                                  .sort((a, b) => a.id - b.id)
                                  .map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o?.at_rls_trx?.at_user?.name || o?.at_rls_vendor?.name}</td>
                                        <td>{o?.type}</td>
                                        <td>{o?.type === "Keuangan" ? o?.at_rls_trx?.at_cvl?.type : o?.type === "SPK" ? o?.at_rls_contract?.cvl_contract_cvl_budget?.type : (o?.at_rls_purchase?.purchase_detail || []).map((m, k) => {
                                          return <div key={k}>{m?.purchase_cvl_budget?.type + ", " + m?.name}</div>
                                        })}</td>
                                        <td>{o?.type === "Keuangan" ? o?.at_rls_trx?.transaction_no : o?.type === "SPK" ? o?.at_rls_contract?.transaction_no : o?.at_rls_purchase?.transaction_no}</td>
                                        <td>{o?.type === "SPK" ? "-" : o?.at_rls_purchase?.transaction_reff}</td>
                                        <td>{currencyFormat(o?.amount)}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      ) : null}
                      <CardBody className="p-3 border-top border-top-dashed position-relative">
                        <div>

                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr>
                                <td colSpan="2" style={{ width: "40%" }}>
                                  <Select
                                    name="paymentMethod"
                                    value={validation.values.paymentMethod}
                                    placeholder="Jenis Transaksi / Jurnal Otomatis"
                                    onChange={(e) => {
                                      let obj = [
                                        {
                                          itemId: 0,
                                          isPrimary: true,
                                          description: "",
                                          sort_order: 1,
                                          debit: validation.values.amount,
                                          credit: 0,
                                          accId: e?.item?.pm_acc_account?.id ?? "",
                                          acc: e?.item?.pm_acc_account?.id ? { label: e?.item?.pm_acc_account?.code + " - " + e?.item?.pm_acc_account?.name, value: e?.item?.pm_acc_account?.id } : "",
                                        },
                                        {
                                          itemId: 0,
                                          isPrimary: false,
                                          description: "",
                                          sort_order: 2,
                                          debit: 0,
                                          credit: validation.values.amount,
                                          accId: e?.item?.pm_accto_account?.id ?? "",
                                          acc: e?.item?.pm_accto_account?.id ? { label: e?.item?.pm_accto_account?.code + " - " + e?.item?.pm_accto_account?.name, value: e?.item?.pm_accto_account?.id } : "",
                                        },
                                      ];

                                      validation.setFieldValue("items", obj);
                                      validation.setFieldValue("paymentMethod", e);
                                      validation.setFieldValue("tag", e.tag);
                                    }}
                                    options={paymentMethodList}
                                  ></Select>
                                  {validation.touched.paymentMethod && validation.errors.paymentMethod && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.paymentMethod}
                                    </small>
                                  )}
                                </td>
                                <td colSpan="3">
                                  <Link
                                    to="#"
                                    className="btn btn-soft-success fw-medium"
                                    id="add-item"
                                    onClick={() => {
                                      handleAccTransDetailAdd();
                                    }}
                                  >
                                    <i className="ri-add-fill me-1 align-bottom"></i>Tambah Akun
                                  </Link>
                                </td>
                              </tr>
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>
                                  #
                                </th>
                                <th scope="col">Akun Detail</th>
                                <th scope="col" style={{ width: "120px" }}>
                                  Debit
                                </th>
                                <th scope="col" style={{ width: "120px" }}>
                                  Credit
                                </th>
                                <th scope="col" style={{ width: "200px" }}>
                                  Keterangan
                                </th>
                                <th scope="col" className="text-end" style={{ width: "35px" }}></th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(validation.values.items || []).map((o, i) => {
                                return (
                                  <tr key={i} id={i} className="product">
                                    <th scope="row" className="product-id">
                                      {i + 1}
                                    </th>
                                    <td className="text-start">
                                      <Select
                                        name="item"
                                        value={validation.values.items[i].acc ?? ""}
                                        placeholder="Pilih Akun"
                                        onChange={(e) => {
                                          validation.values.items[i].acc = e;
                                          validation.values.items[i].accId = e.value;
                                          validation.values.items[i].sort_order = i;
                                          validation.setFieldValue("items", validation.values.items);
                                        }}
                                        options={accountingList}
                                        validate={{ required: { value: true } }}
                                      ></Select>
                                    </td>
                                    <td>
                                      <div>
                                        <CurrencyInput
                                          prefix="Rp. "
                                          style={{ border: "1px solid #ccc", width: "180px" }}
                                          className="form-control product-price"
                                          placeholder="Isi Debit"
                                          value={validation.values.items[i].debit}
                                          decimalsLimit={2}
                                          onFocus={(e) => e.target.select()}
                                          onValueChange={(value, name, values) => {
                                            validation.values.items[i].debit = parseFloat(value);
                                            validation.setFieldValue("items", validation.values.items);
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <CurrencyInput
                                          prefix="Rp. "
                                          style={{ border: "1px solid #ccc", width: "180px" }}
                                          className="form-control product-price"
                                          placeholder="Isi Credit"
                                          value={validation.values.items[i].credit}
                                          decimalsLimit={2}
                                          onFocus={(e) => e.target.select()}
                                          onValueChange={(value, name, values) => {
                                            validation.values.items[i].credit = parseFloat(value);
                                            validation.setFieldValue("items", validation.values.items);
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <Input
                                        name="description"
                                        style={{ width: "280px" }}
                                        type="text"
                                        className="form-control"
                                        value={validation.values.items[i].description}
                                        onChange={(e) => {
                                          validation.values.items[i].description = e.target.value;
                                          validation.setFieldValue("items", validation.values.items);
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </td>
                                    <td>
                                      <Link
                                        to="#"
                                        className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                        onClick={() => {
                                          onClickDeleteDetailItem(i);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}

                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            validation.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>

                        <button type="submit" className={!!isEdit && !!isApprove ? "btn btn-success" : !!isEdit && !!isRelease ? "btn btn-info" : !!isEdit ? "btn btn-primary" : "btn btn-primary"} disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit && !!isApprove ? "APPROVE TRANSAKSI" : !!isEdit && !!isRelease ? "RELEASE PEMBAYARAN TRANSAKSI" : !!isEdit ? "EDIT TRANSAKSI" : "TAMBAH TRANSAKSI"}
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Invoice Detail
                  </ModalHeader>
                  {accTrans !== undefined && accTrans !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4 pb-3 pt-3">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="80" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="80" />
                                <div className="mt-sm-3 mt-3">
                                  <h4 className="text-uppercase fw-semibold mb-1">{info.at_client && info.at_client.name}</h4>
                                  <h5 className=" mb-4 text-uppercase fw-semibold">TRANSAKSI {getType(info.type).label}</h5>
                                  <div className=" mb-2 text-uppercase fw-semibold">PROYEK {info.at_branch && info.at_branch.name}</div>
                                  <div className=" mb-1 text-uppercase hstack">
                                    <div style={{ width: "130px" }}>Department</div>
                                    <div style={{ width: "20px" }}>:</div>
                                    <div>{info.at_department ? info.at_department.name : "-"}</div>
                                  </div>
                                  <div className=" mb-1 text-uppercase hstack">
                                    <div style={{ width: "130px" }}>RAB / ANGGARAN</div>
                                    <div style={{ width: "20px" }}>:</div>
                                    <div>{info?.at_cvl?.name} - {info?.at_cvl_account?.name} / {info?.at_budget?.name ? info?.at_budget?.name : "-"}</div>
                                  </div>
                                  <div className=" mb-1 text-uppercase d-none">Metode Bayar: {info.at_pm ? info.at_pm.name : "-"}</div>
                                  <div className=" mb-1 text-uppercase hstack">
                                    <div style={{ width: "130px" }}>TAG</div><div style={{ width: "20px" }}>:</div>
                                    <div>{info.at_tag ? info.at_tag.name : "-"}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4 pb-3 pt-3">
                            <Row className="g-3">
                              <Col lg={6} xs={6}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">No Transaksi</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{info.transaction_no}</span>
                                </h5>
                              </Col>
                              <Col lg={6} xs={6}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date / Due Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">
                                    {handleValidDate(info.transactionat, "DD/MM/YYYY")} - {handleValidDate(info.dueat, "DD/MM/YYYY")}
                                  </span>
                                </h5>
                              </Col>
                              <Col lg={12} xs={12}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Jumlah</p>
                                <h5 className="fs-3 mb-0 fw-semibold">
                                  <span id="total-amount" className="text-success">
                                    {currencyFormat(info.amount)}
                                  </span>
                                </h5>
                              </Col>
                              <Col lg={12} xs={12}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Terbilang</p>
                                <h5 className="fs-15 mb-0">
                                  <span id="total-amount">{numberToWords(info.amount)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          {(info.at_rls || []).length ? (
                            <CardBody className="p-4 pb-3 pt-3 border-top border-top-dashed position-relative">
                              <div>
                                <h5>Detail Pengajuan Dana</h5>
                                <Table className="invoice-table table-borderless table-nowrap mb-0">
                                  <thead className="align-middle">
                                    <tr className="table-active">
                                      <th scope="col" style={{ width: "20px" }}>
                                        #
                                      </th>
                                      <th scope="col">Supplier / Kontak</th>
                                      <th scope="col">Type</th>
                                      <th scope="col">RAB</th>
                                      <th scope="col">No Transaksi</th>
                                      <th scope="col">No Invoice</th>
                                      <th scope="col">Jumlah Bayar</th>
                                    </tr>
                                  </thead>
                                  <tbody id="newlink">
                                    <tr>
                                      <th></th>
                                      <th colSpan={5}>
                                        Total <em className="fs-11 text-muted fw-normal">jumlah pengajuan harus sama dengan nilai transaksi</em>
                                      </th>
                                      <th className="text-info fs-14">{currencyFormat((info.at_rls || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}</th>
                                    </tr>
                                    {(info.at_rls || [])
                                      .sort((a, b) => a.id - b.id)
                                      .map((o, i) => {
                                        return (
                                          <tr key={i} id={i} className="product">
                                            <th scope="row" className="product-id">
                                              {i + 1}
                                            </th>
                                            <td className="text-start">{o?.at_rls_trx?.at_user?.name || o?.at_rls_vendor?.name}</td>
                                            <td>{o?.type}</td>
                                            <td>{o?.type === "Keuangan" ? o?.at_rls_trx?.at_cvl?.type : o?.type === "SPK" ? o?.at_rls_contract?.cvl_contract_cvl_budget?.type : (o?.at_rls_purchase?.purchase_detail || []).map((m, k) => {
                                              return <div key={k}>{m?.purchase_cvl_budget?.type + ", " + m?.name}</div>
                                            })}</td>
                                            <td>{o?.type === "Keuangan" ? o?.at_rls_trx?.transaction_no : o?.type === "SPK" ? o?.at_rls_contract?.transaction_no : o?.at_rls_purchase?.transaction_no}</td>
                                            <td>{o?.type === "SPK" ? "-" : o?.at_rls_purchase?.transaction_reff}</td>
                                            <td>{currencyFormat(o?.amount)}</td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </Table>
                              </div>
                            </CardBody>
                          ) : null}
                          {info.at_purchase && info.at_purchase.purchase_detail && (
                            <CardBody className="p-4 pb-3 pt-3">
                              <Table className="table-borderless text-center table-nowrap align-middle">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "30px" }}>
                                      #
                                    </th>
                                    <th scope="col" className="text-start">
                                      Detail Produk
                                    </th>
                                    <th scope="col" className="text-start">
                                      Anggaran
                                    </th>
                                    <th scope="col">Harga</th>
                                    <th scope="col">Jumlah</th>
                                    <th scope="col">Penerimaan Barang</th>
                                    <th scope="col" className="text-end">
                                      Total
                                    </th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {(info.at_purchase.purchase_detail || []).map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o.name}</td>
                                        <td className="text-start">{o.cvl_account}</td>
                                        <td>Rp{currencyFormat(o.amount)}</td>
                                        <td>{currencyFormat(o.quantity)}</td>
                                        <td>{currencyFormat(o.accepted)}</td>
                                        <td className="text-end">Rp{currencyFormat(o.amount * o.quantity)}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </CardBody>
                          )}
                          <CardBody className="p-4 pb-3 pt-3">
                            <div className="mt-0 mb-3">
                              <div className="alert alert-item bg-soft-info">
                                <p className="mb-0">
                                  <span className="fw-semibold fs-16">NOTES: </span>
                                  <span id="note" className="fs-14">
                                    {info.description}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <Row className="g-3">
                              <Row className="g-3">
                                <Col lg={4} xs={4}>
                                  <p className="mb-0 text-center">Bogor, {handleValidDate(info.createdat, "DD/MM/YYYY")}</p>
                                  <p className="mb-0 text-center">Pengajuan</p>
                                  <p className="mb-5 pb-3 fw-semibold text-center">{info.at_createdby ? info.at_createdby.name : ""}</p>
                                  <p style={{ height: "10px" }}></p>
                                  <p className="mt-5 text-center">................................</p>
                                </Col>
                                <Col lg={4} xs={4}>
                                  <p className="mb-0 text-center">Bogor, {info.approvedat && info.approvedat ? handleValidDate(info.approvedat) : "................................"}</p>
                                  <p className="mb-0 text-center">Disetujui Oleh</p>
                                  <p className="mb-5 pb-3 fw-semibold text-center">{info.at_approvedby ? info.at_approvedby.name : <span>&nbsp;</span>}</p>
                                  <p style={{ height: "10px" }}></p>
                                  <p className="mt-5 text-center">................................</p>
                                </Col>
                                <Col lg={4} xs={4}>
                                  <p className="mb-0 text-center">Bogor, ....................</p>
                                  <p className="mb-0 text-center">Penerima</p>
                                  <p className="mb-5 pb-3 fw-semibold text-center">{info.at_user ? info.at_user.name : <span>&nbsp;</span>}</p>
                                  <p style={{ height: "10px" }}></p>
                                  <p className="mt-5 text-center">................................</p>
                                </Col>
                              </Row>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4 pb-3 pt-3">
                            <Row className="g-3">
                              {(info.at_file || []).map((f, i) => {
                                if (f.isDeleted) {
                                  return null;
                                } else {
                                  return (
                                    <Col lg={2} xs={2} key={i}>
                                      {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                        <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                      ) : (
                                        <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                          <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                        </Link>
                                      )}
                                    </Col>
                                  );
                                }
                              })}
                            </Row>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleDetail();
                        }}
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalDetailExpense" isOpen={modalDetailExpense} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetailExpense}>
                    Detail Print
                  </ModalHeader>
                  {info !== undefined && info !== null && (
                    <>
                      <PrintDocExpense innerRef={printRef} item={info} />
                    </>
                  )}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleDetailExpense();
                        }}
                      >
                        Close
                      </button>
                      {<ButtonPrint innerRef={printRef} title={`print-${info?.nama ?? ""}`} />}
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    Approve Transaction
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="mt-2 text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <h4>Are you sure ?</h4>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
          <Col sm={4} style={{ position: "relative" }}>
            <Card style={{ position: "sticky", top: "94px" }}>
              <CardHeader>
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1 fw-semibold">#{info.transaction_no}</h5>
                  <div className="flex-shrink-0">{info.statusId === 1 ? <span className="badge text-uppercase badge-soft-warning">DRAFT</span> : info.statusId === 2 ? <span className="badge text-uppercase badge-soft-success">APPROVED</span> : info.statusId === 3 ? <span className="badge text-uppercase badge-soft-info">RELEASED</span> : <span className="badge text-uppercase badge-soft-danger">CANCELED</span>}</div>
                </div>
              </CardHeader>
              <CardBody className="p-3 pt-0">
                <div className="table-responsive mb-3">
                  <Table className="table-nowrap align-middle mb-0">
                    <tbody>
                      <tr>
                        <td className="w-25 p-2 text-muted ps-0"> Jumlah</td>
                        <td className="w-50 p-2">
                          {" "}
                          <span className="mb-2 fw-semibold fs-15 text-info">Rp {currencyFormat(info.amount)}</span>
                        </td>
                      </tr>
                      <tr>
                        <td className="w-25 p-2 text-muted ps-0"> Proyek / Cabang</td>
                        <td className="w-50 p-2">{info.at_branch && info.at_branch.name}</td>
                      </tr>
                      <tr>
                        <td className="w-25 p-2 text-muted ps-0"> Departemen</td>
                        <td className="w-50 p-2">{info.at_department ? info.at_department.name : "-"}</td>
                      </tr>
                      <tr>
                        <td className="w-25 p-2 text-muted ps-0"> Anggaran</td>
                        <td className="w-50 p-2">{info.at_cvl ? info.at_cvl.name : "-"}<br /> {info.at_cvl_account ? info.at_cvl_account.name : "-"}</td>
                      </tr>
                      <tr>
                        <td className="w-25 p-2 text-muted ps-0"> Cash Flow</td>
                        <td className="w-50 p-2">{info.at_branch && info.at_branch.branch_code} - {info.at_budget ? info.at_budget.name : "-"}</td>
                      </tr>
                      <tr>
                        <td className="w-25 p-2 text-muted ps-0"> Jenis Transaksi</td>
                        <td className="w-50 p-2">{info.at_pm ? info.at_pm.name : "-"}</td>
                      </tr>
                      <tr>
                        <td className="w-25 p-2 text-muted ps-0"> Released / Dibayarkan oleh</td>
                        <td className="w-50 p-2">{info.at_rlsdby ? info.at_rlsdby.name : "-"}</td>
                      </tr>
                      <tr>
                        <td className="w-25 p-2 text-muted ps-0"> Bukti Transaksi</td>
                        <td className="w-50 p-2">
                          {(info.at_file || []).map((f, i) => {
                            if (f.isDeleted) {
                              return null;
                            } else {
                              return (
                                <Col lg={2} xs={2} key={i} className="mb-2">
                                  {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                    <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                  ) : (
                                    <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                      <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                    </Link>
                                  )}
                                </Col>
                              );
                            }
                          })}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div className="table-responsive mb-3">
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Journal</p>
                  <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                    <thead>
                      <tr className="table-active">
                        <th scope="col" style={{ width: "20px" }}>
                          #
                        </th>
                        <th scope="col" className="text-start">
                          Akun
                        </th>
                        <th scope="col" style={{ width: "90px" }}>
                          Debit
                        </th>
                        <th scope="col" style={{ width: "90px" }}>
                          Credit
                        </th>
                      </tr>
                    </thead>
                    <tbody id="products-list">
                      {(info.at_detail || []).map((el, i) => {
                        return (
                          <tr key={el.id} className="product">
                            <th scope="row" className="product-id">
                              {i + 1}
                            </th>
                            <td className="text-start fs-12 pt-2 pb-2">
                              <p className="fw-semibold mb-0">{el.at_detail_account && el.at_detail_account.code}</p>
                              <p className="mb-0" style={{ maxWidth: "120px", textOverflow: "ellipsis" }}>
                                {el.at_detail_account && el.at_detail_account.name}
                              </p>
                            </td>
                            <td className="fs-12 fw-semibold">{parseFloat(el.debit) > 0 ? currencyFormat(parseFloat(el.debit)) : ""}</td>
                            <td className="fs-12 fw-semibold">{parseFloat(el.credit) > 0 ? currencyFormat(parseFloat(el.credit)) : ""}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <div className="mb-4">
                  <div className="alert alert-info">
                    <p className="fw-semibold mb-1">NOTES:</p>
                    <p className="mb-0">{info.description}</p>
                  </div>
                </div>
                <div className="row m-0 p-0">
                  <div className="col-lg-6 p-0">
                    <p className="text-muted mb-0 text-uppercase fw-semibold fs-11">Dibuat Oleh</p>
                    <p className="mb-2 text-uppercase fw-semibold">{info.at_createdby ? info.at_createdby.name : "-"}</p>
                  </div>
                  <div className="col-lg-6 p-0">
                    <p className="text-muted mb-0 text-uppercase fw-semibold fs-11">Disetujui Oleh</p>
                    <p className="mb-2 text-uppercase fw-semibold">{info.at_approvedby ? info.at_approvedby.name : "-"}</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printInvoiceRef} item={info} />
      </Container>
    </div>
  );
};

export default AccTrans;
